<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-3">
          <li class="breadcrumb-item">
            <a
              href="#"
              @click.prevent="$router.go(-1)"
            >
              <feather type="arrow-left" />
              {{ $t('editRequest.geri') }}
            </a>
          </li>
        </ol>
      </div>
    </div>
    <div class="clearfix" />

    <input
      id="fileInput"
      ref="file"
      type="file"
      style="display: none"
      @change="setPhoto"
    >

    <!-- Container-fluid starts-->
    <div class="container">
      <div
        v-if="request===null"
        class="card"
      >
        <div class="card-body">
          {{ $t('login.yklnir') }}
        </div>
      </div>

      <div
        v-else
        class="row"
      >
        <div class="col-12">
          <div
            v-if="isMyRequest"
            class="mb-3"
          >
            <div v-if="request.status === 'DRAFT'">
              <div class="alert alert-light shadow">
                {{ $t('request.buSoruQaralamaStasusundadrDigrIstifadilrBuSorunuGr') }}
              </div>
            </div>


            <div v-else-if="request.status === 'WAITING'">
              <div class="alert alert-light shadow">
                {{ $t('request.buSoruAdmininstrasiyaTrfindnYoxlamaGzlyir') }}
              </div>
            </div>


            <div v-else-if="request.status === 'RETURNED'">
              <div class="alert alert-danger shadow">
                {{ $t('request.buSoruAdmininstrasiyaTrfindnGeriQaytarlmdr') }} <br>
                <strong>{{ $t('request.sbb2') }}</strong> {{ request.adminNote }}
                <hr>
                <div class="d-flex justify-content-between align-items-center ">
                  <p>{{ $t('request.sorunuzuTkrarGndrmkIstmirsinizsSilBilrsiniz') }}</p>

                  <button
                    class="btn btn-sm p-2 btn-outline-danger"
                    @click="deleteRequest()"
                  >
                    {{ $t('request.sorunuSil') }}
                  </button>
                </div>
              </div>
            </div>

            <div v-else-if="request.status === 'EXPIRED'">
              <div class="alert alert-warning shadow">
                <span v-if="['REV'].indexOf(request.requestType)>-1">{{ $t('request.ksHrracnVaxtBitib') }}</span>
                <span v-else-if="['AUC'].indexOf(request.requestType)>-1">{{ $t('request.hrracnVaxtBitib') }}</span>
                <span v-else>{{ $t('request.sorunuzunMddtiBitib') }}</span>

                <div class="d-flex justify-content-between align-items-center mt-3 ">
                  <button
                    v-if="!showProlongForm && request.requestType!=='PQT'"
                    class="btn btn-sm p-2 btn-outline-danger"
                    @click="showProlongForm=true"
                  >
                    <span v-if="['REV'].indexOf(request.requestType)>-1">{{ $t('request.ksHrracnMddtiniUzat') }}</span>
                    <span v-else-if="['AUC'].indexOf(request.requestType)>-1">{{
                      $t('request.hrracnMddtiniUzat')
                    }}</span>
                    <span v-else>{{ $t('request.sorununMddtiniUzat') }}</span>
                  </button>
                </div>
              </div>


              <div
                v-if="showProlongForm"
                class="card"
              >
                <div class="card-body ">
                  <form @submit.prevent="prolongRequest">
                    <div class="mb-3">
                      <label>
                        {{ $t('request.yeniMddtiSein') }}
                      </label>
                      <DatePicker
                        v-model="prolongDate"
                        mode="dateTime"
                        :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                        is24hr
                        :minute-increment="15"
                        :min-date="minDeadline"
                        :is-required="true"
                        :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
                      >
                        <template #default="{ inputValue, inputEvents }">
                          <input
                            type="text"
                            class="form-control "
                            :value="inputValue"
                            placeholder=""
                            required
                            v-on="inputEvents"
                          >
                        </template>
                      </DatePicker>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mt-3 ">
                      <button
                        class="btn btn-sm p-2 btn-light-success mr-2"
                        type="submit"
                      >
                        <span>{{ $t('request.yenil') }}</span>
                      </button>
                      <button
                        class="btn btn-sm p-2 btn-light-danger mr-2"
                        type="button"
                        @click="showProlongForm=false"
                      >
                        {{ $t('companyProfile.lvEt') }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div v-else-if="request.status === 'REJECTED'">
              <div class="alert alert-danger shadow">
                {{ $t('request.buSoruAdmininstrasiyaTrfindnPaylalmasnaIcazVerilmy') }} <br>
                <strong>{{ $t('request.sbb2') }}</strong> {{ request.adminNote }}
                <hr>
                <div class="d-flex justify-content-between align-items-center mt-3 ">
                  <button
                    class="btn btn-sm p-2 btn-outline-danger"
                    @click="deleteRequest()"
                  >
                    {{ $t('request.sorunuSil') }}
                  </button>
                </div>
              </div>
            </div>

            <div v-else-if="request.status === 'ACTIVE'">
              <div class="alert alert-success">
                {{ $t('request.sorunuzAktivdir') }}
              </div>
            </div>
            <div v-if=" request.status === 'ACTIVE' || request.status === 'DISCUSSING' ">
              <button
                class="btn btn-light-primary mr-3 mb-2"
                @click.prevent="editRequest()"
              >
                <i class="fa fa-pencil-square mr-1" />
                {{ $t('newAUCRequest.dzliEt') }}
              </button>
            </div>


            <div v-if=" request.status === 'DRAFT' || request.status === 'RETURNED'">
              <div
                v-if=" ['LOG','TRS','RFQ','REV','AUC'].indexOf(request.requestType) >-1 "
                class="mb-4 d-flex justify-content-between align-items-center"
              >
                <div>
                  <button
                    v-if="products.length>0"
                    class="btn btn-primary mr-3 mb-2"
                    :disabled="isPublishing"
                    @click.prevent="publishRequest()"
                  >
                    <span v-if="request.requestType ==='AUC'">{{ $t('request.hrracYaymla') }}</span>
                    <span v-else-if="request.requestType ==='REV'">{{ $t('request.ksHrracYaymla') }}</span>
                    <span v-else>{{ $t('request.sorunuYaymla') }}</span>
                  </button>

                  <button
                    class="btn btn-light-primary mr-3 mb-2"
                    @click.prevent="editRequest()"
                  >
                    <i class="fa fa-pencil-square mr-1" />
                    {{ $t('newAUCRequest.dzliEt') }}
                  </button>
                </div>
                <div>
                  <button
                    class="btn btn-light-danger  ml-3 mb-2"
                    @click="deleteRequest()"
                  >
                    <i class="fa fa-trash mr-1" />
                    <span v-if="request.requestType ==='AUC'">{{ $t('request.hrracSil') }}</span>
                    <span v-else-if="request.requestType ==='REV'">{{ $t('request.ksHrracSil') }}</span>
                    <span v-else>{{ $t('request.sorunuSil') }}</span>
                  </button>
                </div>
              </div>

              <div
                v-else-if=" ['POL'].indexOf(request.requestType) >-1 "
                class="mb-4 d-flex justify-content-between align-items-center"
              >
                <div>
                  <button
                    v-if="pollAnswers.length>1"
                    class="btn btn-primary mr-3 mb-2"
                    :disabled="isPublishing"
                    @click.prevent="publishRequest()"
                  >
                    {{ $t('request.ssvermniYaymla') }}
                  </button>
                  <button
                    class="btn btn-light-primary mr-3 mb-2"
                    @click.prevent="editRequest()"
                  >
                    <i class="fa fa-pencil-square mr-1" />
                    {{ $t('newAUCRequest.dzliEt') }}
                  </button>
                </div>
                <div>
                  <button
                    class="btn btn-light-danger  ml-3 mb-2"
                    @click="deleteRequest()"
                  >
                    <i class="fa fa-trash mr-1" />
                    {{ $t('request.ssvermniSil') }}
                  </button>
                </div>
              </div>

              <div
                v-else
                class="mb-b  d-flex justify-content-between align-items-center"
              >
                <div>
                  <button
                    class="btn btn-primary mr-2 mb-2"
                    :disabled="isPublishing"
                    @click.prevent="publishRequest()"
                  >
                    {{ $t('request.sorunuYaymla') }}
                  </button>

                  <button
                    class="btn btn-light-primary mr-2 mb-2"
                    @click.prevent="editRequest()"
                  >
                    <i class="fa fa-pencil-square mr-1" />
                    {{ $t('newAUCRequest.dzliEt') }}
                  </button>
                </div>
                <div>
                  <button
                    class="btn btn-light-danger  ml-2 mb-2"
                    @click="deleteRequest()"
                  >
                    <i class="fa fa-trash mr-1" />
                    {{ $t('request.sorunuSil') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="printable"
          class="mb-4 col-lg-7"
        >
          <div
            v-if="!isMyRequest && request.user.id === user.id"
            class="card shadow"
          >
            <div class="card-body d-flex justify-content-between">
              <div>
                <p>{{ $t('request.sizBuSorunuBaqaProfillYaratmsnz') }}</p>

                <div class="media">
                  <img
                    class="rounded-circle user-image mr-2 border"
                    :src="getPhoto(request.company.logo,'thumbnailCropped')"
                    alt=""
                    style="width: 50px;"
                  >
                  <div class="about">
                    <div class="name f-w-600">
                      {{ request.company.name }}
                      {{ getCompanyFormat(request.company.format) }}
                    </div>
                    <div class="status">
                      {{ getProfileName(request.profileType) }}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button
                  class="btn  btn-light-primary"
                  @click.prevent="goToCreatorProfile()"
                >
                  {{ $t('request.profilinKe', {getProfileName: getProfileName(request.profileType)}) }}
                </button>
              </div>
            </div>
          </div>

          <div
            v-if="!isMyRequest && conversations.length>0"
            class="card"
          >
            <div class="card-body">
              <p class="lead">
                {{ $t('request.sizinBuSoruIlBalMzakirnizVar') }}
              </p>

              <div
                v-for="c in conversations"
                :key="c.id"
                style="cursor: pointer"
                @click.prevent="$router.push(`/dashboard/conversation/${c.id}`)"
              >
                <div class="d-flex justify-content-between align-items-center my-2">
                  <div class="d-flex align-items-center">
                    <div class="mr-2">
                      <img
                        :src="getPhoto(c.request.user.photo,'thumbnailCropped')"
                        class="img-thumbnail rounded-circle"
                        style="height: 50px;"
                        :alt="$t('offersList.avatar')"
                      >
                    </div>
                    <div>
                      <span class="text-dark">
                        {{ c.request.user.name }}  {{ c.request.user.surname }}
                      </span> <br>
                      <span class="text-primary ">
                        {{ c.request.company.name }} {{ getCompanyFormat(c.request.company.format) }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <span class="btn btn-primary">
                      {{ $t('commentView.mzakiryDavamEt') }}
                    </span>
                    <span
                      v-if="c.open"
                      class="badge badge-success"
                    >{{ $t('request.aktiv') }}</span>
                    <span
                      v-else
                      class="badge badge-danger"
                    >{{ $t('request.tamamlanm') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <div class="badge bg-dark mr-2">
                    {{ requestName }}
                  </div>
                  <div class="badge badge-light mr-2">
                    <img src="@/assets/images/icons/list-order.png">
                    {{ request.requestType }}{{ buildLongId(request.id) }}
                  </div>

                  <div class="badge badge-light mr-2">
                    <img src="@/assets/images/icons/calendar.png">
                    {{ $t('dashboardCompany.key', {moment: getMoment(request.logTime)}) }}
                  </div>
                </div>

                <div v-if="commentCount>0">
                  <span
                    v-if="request.requestType === 'POL'"
                    class="badge badge-primary"
                  >{{ $t('requestItem.ss', {commentCount: commentCount}) }}</span>
                  <span
                    v-else-if="['AUC','REV','RFQ','PQT','LOG'].indexOf(request.requestType)>-1"
                    class="badge badge-primary"
                  >
                    {{ $t('request.commentcountTklif', {commentCount: commentCount}) }}
                  </span>
                  <span
                    v-else
                    class="badge badge-primary"
                  >
                    {{ $t('request.commentcountRh', {commentCount: commentCount}) }}
                  </span>
                </div>
              </div>
              <hr class="mt-3">


              <div class="request-title mb-3">
                {{ request.title }}
              </div>

              <div class="request-description">
                <div class="mb-3">
                  {{ request.description }}
                </div>

                <div
                  v-if="request.requestType === 'AUC'"
                  class="mt-3"
                >
                  <span> {{ $t('request.ilkinQiymt') }} </span>
                  <span class="text-dark">{{
                    $t('aucPrices.azn', {startingPrice: requestExtras.startingPrice})
                  }} </span>
                </div>

                <OfferExtrasView
                  :request="request"
                  :request-extras="requestExtras"
                />
                <LogisticExtrasView
                  :request="request"
                  :request-extras="requestExtras"
                />
                <TRSExtrasView
                  :request="request"
                  :request-extras="requestExtras"
                />
                <TRKExtrasView
                  :request="request"
                  :request-extras="requestExtras"
                />
                <PQTExtrasView
                  :request="request"
                  :request-extras="requestExtras"
                />


                <div
                  v-if="request.requestType==='PQT'"
                  class="mt-2 "
                >
                  <span>{{ $t('request.qaliblrinElanOlunmaTarixi') }} </span>
                  <span class="text-dark"> {{
                    $t('request.newDaterequestextraswinnerdeadlineMomentddMmmYyyyH', {moment: getMoment(requestExtras['winnerDeadline'])})
                  }}</span>
                  <span
                    v-if="request.prolonged"
                    class="text-danger ml-2"
                  >{{ $t("vaxtuzadilib") }}</span>
                </div>
              </div>


              <div
                v-if="files.length>0"
                class="w-75 mt-3"
              >
                <label> {{ $t('request.lavlr') }} </label>

                <div
                  v-for="(f) in files"
                  :key="f.path"
                  class="requestFile py-1"
                >
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <a
                        :href="getPhoto(f.path,'')"
                        target="_blank"
                        class="text-secondary"
                      >
                        <i class="fa fa-paperclip mr-1" />
                        {{ f.path.split('/').pop() }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <hr class="mb-3">
              <div class="d-flex justify-content-between align-items-top">
                <div>
                  <div
                    v-if="request.requestDeadline"
                    class="mt-2 "
                  >
                    <span
                      v-if="request.requestType==='POL'"
                      class="text-secondary"
                    >{{ $t('request.ssvermNSonTarix') }} </span>
                    <span
                      v-else-if="['REV','AUC','LOG','RFQ'].indexOf(request.requestType)>-1"
                      class="text-secondary"
                    >
                      {{ $t('request.tklifNSonTarix') }}
                    </span>
                    <span
                      v-else
                      class="text-secondary"
                    >{{ $t('request.sorununBitmTarixi') }} </span>
                    <br>
                    {{ $t('dashboardCompany.key', {moment: getMoment(request.requestDeadline)}) }}
                    <span
                      v-if="request.prolonged"
                      class="text-success ml-2"
                    >(vaxt uzadılıb)</span>
                  </div>
                </div>

                <div>
                  <span class="badge badge-light font-weight-normal ">
                    <i class="fa fa-eye mr-1" />
                    {{ $t('request.requestviewcountDfBaxlb', {viewCount: request.viewCount}) }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="pollAnswers.length>0">
            <div class="card">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                  <h4> {{ $t('newPolRequest.cavabVariantlar') }} </h4>

                  <div v-if="['DRAFT','RETURNED'].indexOf(request.status)>-1">
                    <button
                      type="button"
                      class="btn btn-sm btn-light-primary"
                      @click.prevent="addPollAnswerOpen = true"
                    >
                      {{ $t('request.yeniVariantLavEt') }}
                    </button>
                  </div>
                </div>
                <hr>
                <div
                  v-for="p in pollAnswers"
                  :key="p.id"
                  class="p-1 my-2 rounded bg-light text-dark"
                >
                  <div class="row">
                    <div
                      v-if="canVote && comments.length<1"
                      class="col-md"
                    >
                      <div
                        v-if="requestExtras.multiSelect>0"
                        class="form-check"
                      >
                        <input
                          :id="`pollAnswer${p.id}`"
                          v-model="selectedPollAnswerList"
                          class="form-check-input"
                          type="checkbox"
                          :value="p.id"
                        >
                        <label
                          class="form-check-label"
                          :for="`pollAnswer${p.id}`"
                        >
                          {{ p.label }}
                        </label>
                      </div>
                      <div
                        v-else
                        class="form-check"
                      >
                        <input
                          :id="`pollAnswer${p.id}`"
                          v-model="selectedPollAnswer"
                          class="form-check-input"
                          type="radio"
                          :value="p.id"
                          name="pollAnswer"
                        >
                        <label
                          class="form-check-label"
                          :for="`pollAnswer${p.id}`"
                        >
                          {{ p.label }}
                        </label>
                      </div>
                    </div>
                    <div
                      v-else
                      class="col-md d-flex align-item-center "
                    >
                      {{ p.label }}
                    </div>
                    <div
                      v-if="['DRAFT','RETURNED'].indexOf(request.status)>-1"
                      class="col-md text-right"
                    >
                      <a
                        class="btn btn-sm btn-light-danger py-2 ml-2"
                        @click.prevent="deletePollAnswer(p.id)"
                      >
                        <i class="fa fa-trash" />
                        {{ $t('newRequest.sil') }}</a>
                    </div>
                    <div
                      v-if="['ACTIVE','CLOSED'].indexOf(request.status)>-1 "
                      class="col-md text-right"
                    >
                      {{ $t('announcement.ss', {selected: p.selected}) }}
                    </div>
                  </div>
                  <div
                    v-if="totalAnswerCount>0"
                    class="progress"
                  >
                    <div
                      class="progress-bar"
                      role="progressbar"
                      aria-valuenow="0"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      :style="{'width': `${p.selected/totalAnswerCount*100}%`}"
                    />
                  </div>
                </div>

                <div
                  v-if="canVote && comments.length<1 && requestExtras.ownVariant>0 "
                  class="card-body border-bottom border-bottom-secondary"
                >
                  <label v-if="requestExtras.multiSelect>0">{{ $t('request.zCavabVariantlarmVergllAyrn') }}</label>
                  <label v-else>{{ $t('request.zCavabVariantm') }}</label>
                  <input
                    v-model="pollOwnAnswers"
                    class="form-control form-control-lg"
                    type="text"
                  >
                </div>

                <div
                  v-if="canVote && comments.length<1"
                  class="card-body"
                >
                  <button
                    class="btn btn-success ml-2"
                    @click.prevent="submitPollAnswer"
                  >
                    {{ $t('request.ssimiQeydAl') }}
                  </button>
                </div>

                <div
                  v-if="comments.length>0"
                  class="mt-3 alert alert-info"
                >
                  <i class="fa fa-info-circle" />
                  {{ $t('request.sizArtqBuSsvermdItirakEtmisiniz') }}
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="addPollAnswerOpen"
            class="card mt-3"
          >
            <div class="card-body">
              <form @submit.prevent="addNewPollAnswer">
                <div class="mb-3">
                  <label> {{ $t('request.yeniCavabVariant') }}</label>
                  <input
                    id="newPollAnswer"
                    v-model="newPollAnswerText"
                    class="form-control"
                    type="text"
                    required
                    autofocus
                    name="newPollAnswer"
                  >
                </div>

                <div class="mb-3">
                  <button
                    class="btn btn-success mr-2"
                    type="submit"
                  >
                    <span>{{ $t('request.lavEt') }}</span>
                  </button>
                  <button
                    class="btn btn-light mr-2"
                    type="button"
                    @click="addPollAnswerOpen=false"
                  >
                    {{ $t('companyProfile.lvEt') }}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <template v-if="['RFQ','PQT','REV','AUC'].indexOf(request.requestType) > -1 ">
            <div class="card shadow">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                  <h4> {{ $t('newAUCRequest.mhsullar') }} </h4>

                  <div v-if="['DRAFT','RETURNED'].indexOf(request.status)>-1">
                    <button
                      type="button"
                      class="btn btn-sm btn-light-primary"
                      @click.prevent="addRFQProduct"
                    >
                      {{ $t('newAUCRequest.yeniMhsulLavEt') }}
                    </button>
                  </div>
                </div>

                <hr>

                <div
                  v-for="(p,i) in products"
                  :key="i"
                  class="p-3 rounded bg-light mb-3 text-dark"
                >
                  <div class="mb-3">
                    <strong class="mr-2">{{ p.name }}</strong>
                    <!-- Bura                     -->
                    <span
                      v-if="p.productType==='PRODUCT'"
                      class="badge bg-success"
                    >{{ $t('newAUCRequest.mhsul') }}</span>
                    <span
                      v-else-if="p.productType==='SERVICE'"
                      class="badge bg-danger"
                    >{{ $t('newAUCRequest.xidmt') }}</span>
                    <span
                      v-else
                      class="badge bg-success"
                    >{{ p.productType }}</span>
                  </div>
                  <p class="mb-3 text-secondary">
                    {{ p.note }}
                  </p>

                  <span class=" text-secondary">{{ $t('request.miqdar') }}</span> <span>{{ p.count }} {{
                    p.unit
                  }}</span>
                  <br>
                  <span class=" text-secondary">{{ $t('request.lavFayl') }} </span>
                  <span v-if="p.photo">
                    <a
                      :href="getPhoto(p.photo,'')"
                      target="_blank"
                    >
                      {{ p.photo.split('/').pop() }}
                    </a>
                  </span>
                  <span v-else>-</span>
                  <br>
                  <span class="text-secondary">{{ $t('request.xsusiTlblr') }} </span>
                  <br>
                  <span
                    v-for="(req, index) in p.requirements"
                    :key="`req-${index}`"
                  >
                    {{ `${index + 1}. ` }}{{ req.requirement }} <br>
                  </span>
                  <div
                    v-if="['DRAFT','RETURNED'].indexOf(request.status)>-1"
                    class="mt-3"
                  >
                    <button
                      type="button"
                      class="btn btn-sm p-2 btn-light-success"
                      @click="editRFQProduct(p)"
                    >
                      <feather
                        type="edit-3"
                        size="12"
                      />
                      {{ $t('newAUCRequest.dzliEt') }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm p-2 btn-light-danger ml-2"
                      @click="deleteProduct(p.id)"
                    >
                      <feather
                        type="trash"
                        size="12"
                      />
                    </button>
                  </div>
                </div>
                <div
                  v-if="products.length<1"
                  class="alert alert-warning"
                >
                  {{ $t('newAUCRequest.mhsulLavEdilmyib') }}
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="['LOG','TRS'].indexOf(request.requestType) > -1 ">
            <div class="card shadow">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                  <h4> {{ $t('request.ykMlumatlar') }} </h4>

                  <div v-if="['DRAFT','RETURNED'].indexOf(request.status)>-1">
                    <button
                      type="button"
                      class="btn btn-sm btn-light-primary"
                      @click.prevent="addLogisticProduct"
                    >
                      {{ $t('request.yeniYkLavEt') }}
                    </button>
                  </div>
                </div>

                <hr>
                <div
                  v-for="p in products"
                  :key="p.id"
                  class="p-3 rounded bg-light mb-3 text-dark"
                >
                  <RequestLogisticProduct :product="p" />

                  <div
                    v-if="['DRAFT','RETURNED'].indexOf(request.status)>-1"
                    class="mt-3"
                  >
                    <button
                      type="button"
                      class="btn btn-sm p-2 btn-light-success"
                      @click="editLogisticProduct(p)"
                    >
                      <feather
                        type="edit-3"
                        size="12"
                      />
                      {{ $t('newAUCRequest.dzliEt') }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm p-2 btn-light-danger ml-2"
                      @click="deleteProduct(p.id)"
                    >
                      <feather
                        type="trash"
                        size="12"
                      />
                    </button>
                  </div>
                </div>

                <div
                  v-if="products.length<1"
                  class="alert alert-warning"
                >
                  {{ $t('request.ykLavEdilmyib') }}
                </div>
              </div>
            </div>
          </template>


          <RequestCountdown
            :request="request"
            :current-time="currentTime"
            @updateRequest="getRequest"
          />


          <div
            v-if="['AUC','REV','PQT'].indexOf(request.requestType) >-1 && !isMyRequest && !isCoWorker"
            class="card"
          >
            <div
              v-if="requestUser"
              class="card-body"
            >
              <div
                v-if="requestUser.userStatus === 'BLOCKED'"
                class="alert alert-danger"
              >
                {{ $t('request.sizinBuSorudaItiraknzMllifTrfindnMhdudladrlb') }}
              </div>
              <div v-else>
                {{ $t('request.sizBuSorudaItirakNmrniz') }}
                <strong class="badge bg-primary lead">{{ $t("requestParticipants.itirak") }}# {{
                  requestUser.userOrder
                }}</strong>
              </div>
            </div>
            <div
              v-else
              class="card-body"
            >
              {{ $t('request.sizBuSorudaItirakEtmmisiniz') }}
            </div>
          </div>
          <RequestFAQ
            v-if="['AUC','REV','RFQ','PQT'].indexOf(request.requestType)>-1 && ['DRAFT','RETURNED','REJECTED'].indexOf(request.status)<0"
            :is-my-request="isMyRequest"
            :can-participate="canOfferStatus ==='yes'"
            :request="request"
            :request-user="requestUser"
          />

          <AUCPrices
            v-if="['AUC','REV'].indexOf(request.requestType)>-1 && ['DRAFT','RETURNED','REJECTED'].indexOf(request.status)<0"
            :can-offer-status="canOfferStatus"
            :request="request"
            :request-extras="requestExtras"
            :request-prices="requestPrices"
            :request-user="requestUser"
            @refresh="getRequest()"
          />

          <div v-if=" isMyRequest && (request.status === 'DRAFT' || request.status === 'RETURNED' )">
            <div v-if=" ['LOG','TRS'].indexOf(request.requestType) >-1 ">
              <div
                v-if="products.length===0"
                class="my-3 alert alert-danger"
              >
                {{ $t('request.sorunuYaymlamaqNNAzBirYkLavEtmlisiniz') }}
              </div>
            </div>
            <div v-else-if=" ['POL'].indexOf(request.requestType) >-1 ">
              <div
                v-if="pollAnswers.length<2"
                class="my-3 alert alert-danger"
              >
                {{ $t('request.sorunuYaymlamaqNNAzIkiSeimLavEtmlisiniz') }}
              </div>
            </div>
            <div v-else-if=" ['RFQ','PQT','REV','AUC'].indexOf(request.requestType) >-1 ">
              <div
                v-if="products.length===0"
                class="my-3 alert alert-danger"
              >
                {{ $t('request.sorunuYaymlamaqNNAzBirMshulVYaXidmtLavEtmlisiniz') }}
              </div>
            </div>
          </div>

          <div
            v-if="['POL'].indexOf(request.requestType) >-1 && ['ACTIVE','EXPIRED','CLOSED'].indexOf(request.status)>-1"
          >
            <div class="card">
              <div class="card-body">
                <div class="d-flex justify-content-between">
                  <div class="lead">
                    {{ $t('request.commentcountSsVerilib', {commentCount: commentCount}) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="['RFQ','LOG', 'PQT'].indexOf(request.requestType) >-1 && ['ACTIVE','CLOSED','EXPIRED','DISCUSSING'].indexOf(request.status)>-1"
          >
            <div v-if="(isCoWorker || isMyRequest) && (commentCount >0 || offers.length >0) ">
              <div v-if="request.requestType ==='PQT'">
                <div
                  class="card"
                >
                  <div
                    v-if="isMyRequest && requestExtras.showBefore!=='true'"
                    class="card-body"
                  >
                    {{ $t('request.sizQiymtlriYalnzMsabiqBitdikdnSonraGrBilcksiz') }}
                  </div>
                </div>

                <div v-if="(isMyRequest || isCoWorker ) && requestExtras.showBefore==='true'">
                  <PQTOffersView
                    :offers="offers"
                    :products="products"
                    :request="request"
                    @openCompanyRatingStatisticPopup="openCompanyRatingStatisticPopup = $event"
                    @refreshData="getRequest"
                  />
                </div>
              </div>
              <div v-else>
                <RFQOffersView
                  :comments="comments"
                  :products="products"
                  :request="request"
                  :conversations="conversations"
                  @reportComment="handleReportView($event)"
                  @openCompanyRatingStatisticPopup="openRatingPopup($event,'SUPPLIER')"
                />
              </div>
            </div>
            <div
              v-if="!isCoWorker && !isMyRequest && offers.length>0"
              class="card"
            >
              <div class="card-body">
                <div class="d-flex justify-content-between">
                  <div class="lead">
                    <span>Sizin əsas qiymət təklifiniz ən münasib {{ offers[0].mainRank }}-ci təklifdir.</span>
                    <br>
                    <span
                      v-if="offers[0].alternativeRank>0"
                      class="text-primary"
                    >Sizin alternativ qiymət təklifiniz ən münasib {{ offers[0].alternativeRank }}-ci təklifdir.</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="d-flex justify-content-between">
                  <div class="lead">
                    {{ $t('request.commentcountTklifVar', {commentCount: commentCount}) }}
                  </div>
                  <div v-if="canOfferStatus==='yes' && comments.length <1 && companyUserCommented ==='' ">
                    <button
                      class="btn btn-primary"
                      @click.prevent="$bvModal.show('modal-price-offer')"
                    >
                      <span v-if="offers.length>0">{{ $t('request.tklifiDyi') }}</span>
                      <span v-else>{{ $t('request.tklifVer') }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="canOfferStatus!=='yes'
              && canOfferStatus !=='no_offer_allowed'
              && canOfferStatus !=='own_request'
              && ['DRAFT','RETURNED','REJECTED'].indexOf(request.status)<0 && !isCoWorker
            "
          >
            <RequestCanNotCommentOfferView
              :status="canOfferStatus"
              :request="request"
              :sectors="sectors"
              :company-participation-user="companyUserCommented"
              @refresh="getRequest"
              @openProcurementRating="openRatingPopup($event,'PROCUREMENT')"
            />
          </div>


          <div>
            <div v-if="offers.length>0 && request.requestType ==='PQT' && !isMyRequest && !isCoWorker ">
              <MyPQTOffer
                :offers="offers"
                :request="request"
                :products="products"
              />
            </div>
            <div
              v-else
              class="social-chat"
            >
              <div
                v-for="c in comments"
                :key="c.id"
              >
                <MyRFQOffer
                  v-if="c.type === 'RFQ_PRICE'"
                  :comment="c"
                  :request="request"
                  :conversations="conversations"
                  :products="products"
                />

                <MyLOGOffer
                  v-else-if="c.type === 'LOG_PRICE'"
                  :products="products"
                  :comment="c"
                />

                <MyPOLVote
                  v-else-if="c.type === 'POLL_VOTE'"
                  :comment="c"
                />

                <CommentView
                  v-else
                  :comment="c"
                  :conversations="conversations"
                  :is-my-request="isMyRequest"
                />
              </div>
            </div>
          </div>

          <div
            v-if="request.status === 'CLOSED' && isMyRequest "
            class="alert alert-danger"
          >
            {{ $t('request.buSorunuBalamsnz') }}
          </div>
          <div
            v-if="canCommentStatus==='yes'"
            class="social-chat"
          >
            <div class="your-msg">
              <div class="media">
                <img
                  class="img-50 img-fluid m-r-20 rounded-circle"
                  alt=""
                  :src="getPhoto(user.photo,'mediumCropped')"
                >
                <div class="media-body bg-white">
                  <div class="d-flex justify-content-between align-items-top mb-3">
                    <span class="f-w-600">
                      {{ user.name }} {{ user.surname }} <br>
                      <span class="text-primary">
                        {{ company.name }} {{ getCompanyFormat(company.format) }} ({{ position }}')
                      </span>
                    </span>
                    <em class="text-secondary">
                      <feather
                        v-if="!privateComment"
                        type="globe"
                        stroke="green"
                        size="24px"
                        @click.prevent="privateComment = true"
                      />
                      <feather
                        v-if="privateComment"
                        type="lock"
                        stroke="red"
                        size="24px"
                        @click.prevent="privateComment = false"
                      />
                    </em>
                  </div>

                  <form @submit.prevent="comment">
                    <div class="mb-3">
                      <textarea
                        v-model="commentText"
                        class="form-control"
                        rows="3"
                        :placeholder="$t('request.mesajnz')"
                      />
                    </div>
                    <div>
                      <button
                        type="submit"
                        class="btn btn-outline-primary"
                      >
                        {{ $t('body.gndr') }}
                      </button>


                      <button
                        type="button"
                        class="btn btn-lg btn-outline-primary py-1 px-2 ml-3"
                        @click.prevent="selectPhoto"
                      >
                        <feather
                          type="upload-cloud"
                          size="18px"
                        />
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="canCommentStatus!=='no_comment_allowed' && ['DRAFT','RETURNED','REJECTED'].indexOf(request.status)<0 "
          >
            <RequestCanNotCommentOfferView
              :status="canCommentStatus"
              :request="request"
              :sectors="sectors"
              :company-participation-user="companyUserCommented"
              @refresh="getRequest"
              @openProcurementRating="openRatingPopup($event,'PROCUREMENT')"
            />
          </div>

          <RequestParticipants
            v-if="['AUC', 'REV','PQT'].indexOf(request.requestType) > -1"
            :request="request"
            :is-my-request="isMyRequest"
          />

          <RequestConversations
            v-if="conversations.length > 0 && isMyRequest"
            :request="request"
            :conversations="conversations"
          />

          <div
            v-if="request.status === 'CLOSED' && requestWinners.length >0"
            class="card"
          >
            <div class="card-header">
              <h4 class="mb-0">
                {{ $t('purchases.qalib') }}
              </h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div
                  v-for="w in requestWinners"
                  :key="w.id"
                  class="col-md-6"
                >
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <img
                          :src="getPhoto(w.user.photo,'thumbnailCropped')"
                          class="img-thumbnail rounded-circle"
                          style="height: 50px;"
                          :alt="$t('request.userAvatar')"
                        >
                      </div>
                      <div>
                        <span class="text-dark">
                          {{ w.user.name }}  {{ w.user.surname }}
                        </span> <br>
                        <span class="text-primary ">
                          {{ w.company.name }} {{ getCompanyFormat(w.company.format) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 ">
          <div class="card shadow">
            <div class="card-body">
              <h4>{{ $t('request.soruMllifi') }}</h4>
              <hr class="my-3">
              <div class="d-flex justify-content-between align-items-top">
                <div class="d-flex align-items-center">
                  <img
                    class="rounded-circle img-thumbnail mr-2"
                    style="width: 70px; "
                    :src="getPhoto(request.user.photo,'thumbnailCropped')"
                    alt=""
                  >
                  <div>
                    <strong>{{ request.user.name }} {{ request.user.surname }}</strong> <br>
                    {{ request.position }} /
                    <span class="text-primary">{{ request.company.name }} {{
                      getCompanyFormat(request.company.format)
                    }}</span>
                  </div>
                </div>

                <div
                  v-if="!request.private"
                  style="cursor: pointer"
                  class="text-center"
                  @click.prevent="openRatingPopup(request.company.id, request.profileType)"
                >
                  <div v-if="request.profileType === 'PROCUREMENT'">
                    <StarRatingView
                      :count="request.company.procurementRateCount"
                      :total="request.company.procurementRateTotal"
                      :single-star="true"
                    />
                  </div>

                  <div v-else-if="request.profileType === 'SUPPLIER'">
                    <StarRatingView
                      :count="request.company.supplyRateCount"
                      :total="request.company.supplyRateTotal"
                      :single-star="true"
                    />
                  </div>
                  <div v-else>
                    <StarRatingView
                      :count="0"
                      :total="0"
                      :single-star="true"
                    />
                  </div>
                </div>
              </div>
              <div v-if="isCoWorker">
                <hr>
                <div class="alert alert-info">
                  {{ $t('request.sizBuSorununNzartisisiniz') }}
                </div>
              </div>
              <div v-if="isMyRequest && ['RFQ','PQT'].indexOf( request.requestType)>-1 ">
                <hr>
                <h4>{{ $t('request.soruNzartisi') }}</h4>
                <p>
                  {{ $t('request.soruyaVGlnTkliflrSizinlEyniAndaBaxaBilmsiNRhbrXsiV') }}
                </p>

                <div
                  v-if="coWorker"
                  class="d-flex align-items-center"
                >
                  <img
                    class="rounded-circle img-thumbnail mr-2"
                    style="width: 70px; "
                    :src="getPhoto(coWorker.photo,'thumbnailCropped')"
                    alt=""
                  >
                  <div>
                    <strong>{{ coWorker.name }} {{ coWorker.surname }}</strong> <br>
                    {{ coWorkerPosition }}
                  </div>
                </div>
                <div v-else-if="request.status==='ACTIVE'">
                  <div
                    v-if="company.legalForm==='PERSONAL'"
                    class="alert alert-warning"
                  >
                    {{ $t('request.buFunksiyanYalnzVenSahiblriIstifadEdBilr') }}
                  </div>
                  <div v-else>
                    <button
                      class="btn btn-sm btn-light-primary"
                      type="button"
                      @click.prevent="showCoWorkerPopup"
                    >
                      {{ $t('request.nzartiTyinEt2') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <RequestCloseFlow
            :is-my-request="isMyRequest"
            :request="request"
            :comments="comments"
            :offers="offers"
            @refresh="getRequest()"
          />

          <div
            v-if="['RETURNED','REJECTED','DRAFT'].indexOf(request.status)<0"
            class="card shadow"
          >
            <div class="card-body">
              <h4>{{ $t('request.sorunuPayla') }}</h4>
              <hr class="my-2">
              <ShareNetwork
                v-for="network in networks"
                :key="network.name"
                :network="network.name"
                :url="fullUrl"
                :title="request.title"
                :description="request.description"
                :class="`btn btn-sm py-2 ${network.btnClass} m-2`"
              >
                <i
                  :class="network.iconClass"
                  aria-hidden="true"
                /> {{ $t(network.translationKey) }}
              </ShareNetwork>
              <button
                class="btn btn-success  py-2 m-2"
                @click="printSection('printable')"
              >
                <i class="fa fa-print" />Print
              </button>
              <template v-if="request.user.id !== user.id">
                <button
                  v-if="isFavorite"
                  class="btn  btn-sm m-2 py-2 btn-light-warning"
                  @click.prevent="deleteFromFavorites()"
                >
                  <i
                    class="fa fa-minus-circle mr-2"
                    aria-hidden="true"
                  />
                  {{ $t('request.seilmilrdnSil') }}
                </button>
                <button
                  v-else
                  class="btn  btn-sm m-2 py-2 btn-light-primary"
                  @click.prevent="addToFavorites()"
                >
                  <i
                    class="fa fa-heart mr-2"
                    aria-hidden="true"
                  />
                  {{ $t('request.seilmilrLavEt') }}
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
    <b-modal
      id="modal-comment-report"
      centered
      :title="$t('request.ikaytEt2')"
      :hide-footer="true"
      class="theme-modal"
    >
      <div>
        <form @submit.prevent="reportComment">
          <div class="form-check mb-3">
            <input
              id="reportCommnetReason1"
              v-model="reportingCommentReason"
              class="form-check-input"
              type="radio"
              name="reportCommentReason"
              :value="$t('request.qiymtYerinSimvolikRqmVModelYerinLaqMlumatQeydEdib')"
            >
            <label
              class="form-check-label"
              for="reportCommnetReason1"
            >
              {{ $t('request.qiymtYerinSimvolikRqmVModelYerinLaqMlumatQeydEdib') }}
            </label>
          </div>
          <div class="form-check mb-3">
            <input
              id="reportCommnetReason2"
              v-model="reportingCommentReason"
              class="form-check-input"
              type="radio"
              name="reportCommentReason"
              :value="$t('request.mzakirEtmkNCavabVermir')"
            >
            <label
              class="form-check-label"
              for="reportCommnetReason2"
            >{{ $t('request.mzakirEtmkNCavabVermir') }}</label>
          </div>
          <div class="form-check mb-3">
            <input
              id="reportCommnetReason3"
              v-model="reportingCommentReason"
              class="form-check-input"
              type="radio"
              name="reportCommentReason"
              :value="$t('request.alternativTklifEtdiyiMhsulTlbimizlLaqsiYoxdur')"
            >
            <label
              class="form-check-label"
              for="reportCommnetReason3"
            >{{ $t('request.alternativTklifEtdiyiMhsulTlbimizlLaqsiYoxdur') }}</label>
          </div>
          <div class="mb-3">
            <button
              class="btn btn-danger"
              type="submit"
            >
              {{ $t('request.ikaytEt') }}
            </button>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal
      id="modal-product-create"
      centered
      :title="$t('request.mhsulXidmt')"
      size="xl"
      :hide-footer="true"
      class="theme-modal"
    >
      <div class="card-body">
        <div
          v-if="newRFQProduct.id>0"
          class="lead mb-2"
        >
          # {{ newRFQProduct.id }}
        </div>

        <form @submit.prevent="addNewRFQProduct">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label>{{ $t('newAUCRequest.tip') }}</label>
                <select
                  v-model="newRFQProduct.productType"
                  class="form-control"
                  required
                >
                  <option value="PRODUCT">
                    {{ $t('newAUCRequest.mhsul') }}
                  </option>
                  <option value="SERVICE">
                    {{ $t('newAUCRequest.xidmt') }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label>{{ $t('newAUCRequest.mhsulunXidmtinAd') }}</label>
                <input
                  v-model="newRFQProduct.name"
                  class="form-control"
                  type="text"
                  required
                >
              </div>

              <div class="mb-3">
                <label>{{ $t('newAUCRequest.mhsulXidmtHaqqndaQeydlr') }}</label>
                <textarea
                  v-model="newRFQProduct.notes"
                  class="form-control"
                  type="text"
                />
              </div>


              <div class="mb-3">
                <div class="row">
                  <div class="col-6">
                    <label>{{ $t('newAUCRequest.miqdar') }}</label>
                    <input
                      v-model="newRFQProduct.count"
                      class="form-control"
                      type="number"
                      step="0.01"
                      required
                    >
                  </div>
                  <div class="col-6">
                    <label>{{ $t('newAUCRequest.lVahidi') }}</label>
                    <select
                      v-if="newRFQProduct.productType==='SERVICE'"
                      v-model="newRFQProduct.unit"
                      class="form-control"
                      required
                    >
                      <option
                        v-for="v in serviceUnits"
                        :key="v"
                        :value="v"
                      >
                        {{ v }}
                      </option>
                    </select>
                    <select
                      v-else
                      v-model="newRFQProduct.unit"
                      class="form-control"
                      required
                    >
                      <option
                        v-for="v in productUnits"
                        :key="v"
                        :value="v"
                      >
                        {{ v }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <label>{{ $t('newAUCRequest.lavFayl') }}</label> <br>


              <div v-if="newRFQProduct.photo">
                <img
                  v-if="isPhoto(newRFQProduct.photo)"
                  :src="getPhoto(newRFQProduct.photo,'mediumCropped')"
                  alt=""
                  class="img-thumbnail"
                  style="max-height: 300px; max-width: 100%;"
                >
                <div
                  v-else
                  class="p-3 border border-secondary rounded"
                >
                  *.{{ newRFQProduct.photo.split('.').pop() }} {{ $t('request.newrfqproductphotosplitpopFayl') }}
                </div>
              </div>
              <div class="mt-2 ">
                <button
                  type="button"
                  class="btn btn-sm mr-2 btn-light-primary"
                  @click.prevent="selectPhoto(1)"
                >
                  {{ $t('newAUCRequest.ykl') }}
                </button>
                <button
                  v-if="newRFQProduct.photo"
                  type="button"
                  class="btn btn-sm  mr-2 btn-light-danger"
                  @click.prevent="newRFQProduct.photo=''"
                >
                  <i class="fa fa-trash" />
                </button>
                <br>
                <div>
                  <br>
                  <label>{{ $t('newAUCRequest.specialRequirements') }}</label>
                  <br>
                  <!-- Use the specialRequirements of the editingProduct -->
                  <div
                    v-for="(req, index) in newRFQProduct.specialRequirements"
                    :key="index"
                    class="mb-2"
                  >
                    <div class="input-group">
                      <input
                        v-model="req.requirement"
                        type="text"
                        class="form-control"
                        required
                        :placeholder="$t('newAUCRequest.enterSpecialRequirement')"
                      >
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-danger"
                          type="button"
                          @click="removeSpecialRequirementFromProduct(index)"
                        >
                          <i class="fa fa-trash" />
                        </button>
                        <div class="form-check d-flex align-items-center ml-3">
                          <input
                            v-model="req.mandatory"
                            class="form-check-input"
                            type="checkbox"
                          >
                          <label
                            class="form-check-label ml-2"
                          >
                            {{ $t('newRFQRequest.mandatoryReply') }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Check the length of the specialRequirements for the editingProduct -->

                  <button
                    v-if="newRFQProduct.specialRequirements?.length < 5"
                    type="button"
                    class="btn btn-outline-primary"
                    @click="addSpecialRequirementToProduct"
                  >
                    {{ $t('newAUCRequest.addSpecialRequirement') }}
                  </button>
                </div>
              </div>
            </div>


            <div class="col-md-6 mb-3">
              <button
                class="btn btn-success mr-2"
                type="submit"
              >
                <span v-if="newRFQProduct.id>0">{{ $t('sectorSelectionModal.yaddaSaxla') }}</span>
                <span v-else>{{ $t('request.lavEt') }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal
      id="modal-logistic-product-create"
      centered
      :title="$t('request.ykMlumatlar')"
      size="lg"
      :hide-footer="true"
      class="theme-modal"
    >
      <form @submit.prevent="addNewLogisticProduct">
        <div class="row m-2">
          <div class="col-md-6 mb-3">
            <label>{{ $t('request.yknAd') }}</label>
            <input
              v-model="newLogisticProduct.name"
              type="text"
              class="form-control"
              required
            >
          </div>

          <div class="col-md-6 mb-3">
            <label>{{ $t('request.hsKod') }}</label>
            <div class="input-group">
              <input
                v-model="newLogisticProduct.hsCode"
                type="text"
                class="form-control"
              >
              <div class="input-group-append">
                <a
                  class="input-group-text"
                  target="_blank"
                  href="https://c2b.customs.gov.az/Tnved_public.aspx"
                >
                  <i class="fa fa-info" />
                </a>
              </div>
            </div>
          </div>

          <div class=" col-12">
            <hr>
            <h4>
              {{ $t('newAUCRequest.miqdar') }}
            </h4>
          </div>
          <div class="col-md-4 mb-3">
            <label>{{ $t('request.say') }}</label>
            <input
              v-model.number="newLogisticProduct.count"
              type="number"
              class="form-control"
              step="1"
              required
            >
          </div>
          <div class="col-md-4 mb-3">
            <label>{{ $t('newAUCRequest.lVahidi') }}</label>
            <select
              v-model="newLogisticProduct.unit"
              class="form-control"
              required
            >
              <option
                v-for="v in loadUnits"
                :key="v"
                :value="v"
              >
                {{ v }}
              </option>
            </select>
          </div>
          <div class="col-md-4 mb-3">
            <label>{{ $t('request.qabladrmaFormas') }}</label>
            <input
              v-model="newLogisticProduct.package"
              type="text"
              class="form-control"
              required
            >
          </div>

          <div class=" col-12 ">
            <hr>
            <h4>
              {{ $t('request.1DdNLlri') }}
            </h4>
          </div>
          <div class="col-md-2 mb-3">
            <label>{{ $t('request.eni') }}</label>
            <input
              v-model.number="newLogisticProduct.width"
              type="number"
              class="form-control"
              required
            >
          </div>
          <div class="col-md-2 mb-3">
            <label>{{ $t('request.uzunluu') }}</label>
            <input
              v-model.number="newLogisticProduct.length"
              type="number"
              class="form-control"
              required
            >
          </div>
          <div class="col-md-2 mb-3">
            <label>{{ $t('request.hndrly') }}</label>
            <input
              v-model.number="newLogisticProduct.height"
              type="number"
              class="form-control"
              required
            >
          </div>

          <div class="col-md-2 mb-3">
            <label>{{ $t('newAUCRequest.lVahidi') }}</label>
            <select
              v-model="newLogisticProduct.sizeUnit"
              class="form-control"
            >
              <option value="m">
                {{ $t('request.m') }}
              </option>
              <option value="cm">
                {{ $t('request.sm') }}
              </option>
            </select>
          </div>

          <div class="col-md-4 mb-3">
            <label>{{ $t('request.bruttoKisi') }}</label>
            <div class="input-group">
              <input
                v-model.number="newLogisticProduct.weight"
                type="number"
                class="form-control"
                required
              >
              <div class="input-group-append">
                <div class="input-group-text">
                  {{ $t('request.kq') }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <hr>
          </div>


          <div class="col-md-6 mb-3">
            <div class="mb-3">
              <label>{{ $t('request.yknNv') }}</label>
              <select
                v-model="newLogisticProduct.productType"
                class="form-control"
              >
                <option value="basic">
                  {{ $t('request.sadYk') }}
                </option>
                <option value="temperature">
                  {{ $t('request.temperaturRejimliYk') }}
                </option>
                <option value="dangerous">
                  {{ $t('request.thlkliYk') }}
                </option>
              </select>
            </div>
            <div v-if="newLogisticProduct.productType === 'dangerous'">
              <div class="mb-3">
                <label>{{ $t('request.adrKodu') }}</label>
                <div class="input-group">
                  <input
                    v-model="newLogisticProduct.adrCode"
                    type="text"
                    class="form-control"
                    required
                  >
                  <div class="input-group-append">
                    <a
                      class="input-group-text"
                      target="_blank"
                      href="/dashboard/page/adr_codes"
                    >
                      <i class="fa fa-info" />
                    </a>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label>{{ $t('request.unKodu') }}</label>
                <div class="input-group">
                  <input
                    v-model="newLogisticProduct.unCode"
                    type="text"
                    class="form-control"
                  >
                  <div class="input-group-append">
                    <a
                      class="input-group-text"
                      target="_blank"
                      href="#"
                      @click.prevent="showUNPopup"
                    >
                      <i class="fa fa-info" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="newLogisticProduct.productType === 'temperature'">
              <div class="mb-3">
                <label>{{ $t('request.temperatur') }}</label>
                <div class="input-group">
                  <input
                    v-model.number="newLogisticProduct.temperature"
                    type="number"
                    class="form-control"
                    required
                  >

                  <select
                    v-model="newLogisticProduct.temperatureUnit"
                    class="form-control"
                  >
                    <option value="C">
                      {{ $t('request.c') }}
                    </option>
                    <option value="F">
                      {{ $t('request.f') }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="checkbox checkbox-success mb-3">
              <b-form-checkbox
                v-model="newLogisticProduct.canBeStacked"
                value="1"
              >
                {{ $t('request.ykStstQoyulaBilndir') }}
              </b-form-checkbox>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label>{{ $t('request.lavQeydlr') }}</label>
            <textarea
              v-model.number="newLogisticProduct.notes"
              class="form-control"
            />
          </div>

          <div class="col-md-12 mb-3">
            <button
              class="btn btn-success mr-2"
              type="submit"
            >
              <span v-if="newLogisticProduct.id>0">{{ $t('sectorSelectionModal.yaddaSaxla') }}</span>
              <span v-else>{{ $t('request.lavEt') }}</span>
            </button>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal
      id="modal-price-offer"
      centered
      :title="$t('request.tklifVer')"
      :hide-footer="true"
      size="xl"
      class="theme-modal"
    >
      <div v-if="canOfferStatus=== 'yes'">
        <div v-if="request.requestType ==='RFQ'">
          <form @submit.prevent="sendPriceOffer">
            <div
              v-for="p in products"
              :key="p.id"
              class="card border"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-2">
                    <strong>{{ p.name }}</strong> <br>
                    {{ $t('request.qeyd', {note: p.note}) }} <br>
                    {{ p.count }} {{ p.unit }}
                  </div>
                  <div class="col-1">
                    <a
                      v-if="p.photo && p.photo !== 'null'"
                      :href="getPhoto(p.photo,'')"
                      class="d-block"
                      target="_blank"
                      style="background-size: cover; background-position: center; padding-bottom: 100%"
                      :style="{'background-image': `url('${getPhoto(p.photo,'mediumCropped')}')`}"
                    />
                  </div>
                  <div class="col-9">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="mb-3">
                          <div class="form-check">
                            <input
                              :id="`alternativeCheckbox_${p.id}`"
                              v-model="alternativeProducts"
                              class="form-check-input"
                              type="checkbox"
                              :value="p.id"
                              @change="alternativeChanged(p.id, $event)"
                            >
                            <label
                              class="form-check-label"
                              :for="`alternativeCheckbox_${p.id}`"
                            >
                              {{ $t('request.alternativTklif') }}
                            </label>
                          </div>
                        </div>
                      </div>


                      <div class="col-md-12">
                        <div
                          v-if="alternativeProducts.indexOf(p.id)>-1"
                          class="row"
                        >
                          <div class=" col-md-6 mb-3">
                            <label>{{ $t('myRfqOffer.alternativMhsul') }}</label>
                            <input
                              v-model="priceList.alternative[p.id+''].name"
                              type="text"
                              :placeholder="$t('request.markaModel')"
                              class="form-control"
                              required
                            >
                          </div>

                          <div class=" col-md-6 mb-3">
                            <label>{{ $t('request.sbb') }}</label>
                            <select
                              v-model="priceList.alternative[p.id+''].reason"
                              class="form-control"
                              required
                            >
                              <option>{{ $t('request.mhsulunBuraxlDayandrlmdrvzedicisiVar') }}</option>
                              <option>{{ $t('request.stokumuzdaBunaOxarMhsulOlduuN') }}</option>
                              <option>{{ $t('request.eyniQiymtDahaStnFunksiyalModelTklifEdirik') }}</option>
                            </select>
                          </div>

                          <div class=" col-md-6 mb-3">
                            <label>{{ $t('request.1NQiymt', {unit: p.unit}) }}</label>
                            <div class="input-group">
                              <input
                                v-model="priceList.alternative[p.id+''].price"
                                type="number"
                                step="0.01"
                                min="0.01"
                                class="form-control"
                                required
                              >
                              <div class="input-group-text">
                                {{ $t('newAUCRequest.azn') }}
                              </div>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-check mb-2">
                              <input
                                :id="`totalPriceCheckbox_${p.id}`"
                                v-model="totalPriceProducts"
                                class="form-check-input"
                                type="checkbox"
                                :value="p.id"
                              >
                              <label
                                class="form-check-label"
                                :for="`totalPriceCheckbox_${p.id}`"
                              >
                                {{ $t('request.nToplamQiymt', {count: p.count, unit: p.unit}) }}
                              </label>
                            </div>

                            <div v-if="totalPriceProducts.indexOf(p.id)>-1">
                              <div class="input-group">
                                <input
                                  v-model="priceList.alternative[p.id+''].totalPrice"
                                  type="number"
                                  step="0.01"
                                  min="0.01"
                                  class="form-control"
                                  required
                                >
                                <div class="input-group-text">
                                  {{ $t('newAUCRequest.azn') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-else
                          class=" row mb-3"
                        >
                          <div class="col-md-6 mb-3">
                            <label>{{ $t('request.1NQiymt', {unit: p.unit}) }}</label>
                            <div class="input-group">
                              <input
                                v-model="priceList.prices[p.id+'']"
                                type="number"
                                step="0.01"
                                min="0.01"
                                class="form-control"
                                required
                              >
                              <div class="input-group-text">
                                {{ $t('newAUCRequest.azn') }}
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 mb-3">
                            <div class="form-check mb-2">
                              <input
                                :id="`totalPriceCheckbox_${p.id}`"
                                v-model="totalPriceProducts"
                                class="form-check-input"
                                type="checkbox"
                                :value="p.id"
                              >
                              <label
                                class="form-check-label"
                                :for="`totalPriceCheckbox_${p.id}`"
                              >
                                {{ $t('request.nToplamQiymt', {count: p.count, unit: p.unit}) }}
                              </label>
                            </div>


                            <div v-if="totalPriceProducts.indexOf(p.id)>-1">
                              <div class="input-group">
                                <input
                                  v-model="priceList.totalPrices[p.id+'']"
                                  type="number"
                                  step="0.01"
                                  min="0.01"
                                  class="form-control"
                                  required
                                >
                                <div class="input-group-text">
                                  {{ $t('newAUCRequest.azn') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="mb-3">
                          <label>{{ $t('request.qiymtDvDaxildirmi') }}</label>

                          <select
                            v-model.number="priceList.taxIncluded[p.id+'']"
                            class="form-control"
                            required
                          >
                            <option value="0">
                              {{ $t('request.dvDaxil') }}
                            </option>
                            <option value="1">
                              {{ $t('request.dvXaric') }}
                            </option>
                            <option value="2">
                              {{ $t('request.sadldirilmiVergiDyicisi') }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="my-3 text-danger">
              {{ $t('request.mhsulBardQeyriUyunInformasiyaQeydinGrSatnalmaTrfin2') }}
            </div>
            <div class="my-3">
              <button
                class="btn btn-success"
                type="submit"
              >
                {{ $t('request.tklifGndr') }}
              </button>
            </div>
          </form>
        </div>
        <div v-if="request.requestType ==='PQT'">
          <form @submit.prevent="sendPQTPriceOffer">
            <div
              v-for="p in products"
              :key="p.id"
              class="card border"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-2">
                    <strong>{{ p.name }}</strong> <br>
                    {{ $t('request.qeyd', {note: p.note}) }} <br>
                    {{ $t('request.eded', {count: p.count, unit: p.unit}) }}
                  </div>
                  <div class="col-3">
                    <a
                      v-if="p.photo && p.photo !== 'null'"
                      :href="getPhoto(p.photo,'')"
                      class="d-block"
                      target="_blank"
                      style="background-size: cover; background-position: center; padding-bottom: 100%"
                      :style="{'background-image': `url('${getPhoto(p.photo,'mediumCropped')}')`}"
                    />
                  </div>
                  <div class="col-7">
                    <div class="mb-3">
                      <div class="form-group">
                        <div class="row align-items-end">
                          <!-- Product Price -->
                          <div class="col-3 text-center">
                            <label
                              :for="'priceInput-' + p.id"
                              class="d-block"
                            >Məhsulun vahid üzrə qiyməti</label>
                            <input
                              :id="'priceInput-' + p.id"
                              v-model.number="priceList.prices[p.id+''].price"
                              type="number"
                              class="form-control"
                              step="0.01"
                              required
                            >
                          </div>
                          <div
                            class="col-1 text-center"
                            style="padding: 0"
                          >
                            <span
                              class="badge badge-pill badge-danger"
                              style="font-size: 1.1rem;"
                            >x{{ p.count }}</span>
                          </div>
                          <!-- VAT Percentage -->
                          <div class="col-2 text-center">
                            <label
                              :for="'vatInput-' + p.id"
                              class="d-block"
                            >ƏDV faizi</label>
                            <input
                              :id="'vatInput-' + p.id"
                              :value="priceList.prices[p.id+''].isVatPayer === 'true'
                                ? ((priceList.prices[p.id+''].price * 0.18)* p.count).toFixed(2)
                                : 0"
                              type="text"
                              class="form-control"
                              disabled
                              required
                            >
                          </div>

                          <!-- Total Price -->
                          <div class="col-3 text-center">
                            <label
                              :for="'totalInput-' + p.id"
                              class="d-block"
                            >Toplam qiymət</label>
                            <input
                              :id="'totalInput-' + p.id"
                              disabled="disabled"
                              :value="Number(
                                (
                                  priceList.prices[p.id+''].price
                                  * (priceList.prices[p.id+''].isVatPayer==='true' ? 1.18 : 1)
                                  * p.count
                                ).toFixed(2)
                              )"
                              type="text"
                              class="form-control"
                              required
                            >
                          </div>

                          <!-- VAT Payer Radios -->
                          <div class="col-3 ">
                            <div class="form-group mb-0">
                              <div class="radio radio-primary">
                                <div class="custom-control custom-radio">
                                  <input
                                    :id="'isVatPayerTrue-' + p.id"
                                    :checked="priceList.prices[p.id+''].isVatPayer === 'true'"
                                    type="radio"
                                    :name="'isVatPayer-' + p.id"
                                    class="custom-control-input"
                                    value="true"
                                    required
                                    @change="updateVatPayer(p.id+'', 'true')"
                                  >
                                  <label
                                    :for="'isVatPayerTrue-' + p.id"
                                    class="custom-control-label"
                                  >
                                    ƏDV ödəyicisiyəm
                                  </label>
                                </div>
                              </div>
                              <div class="radio radio-primary">
                                <div class="custom-control custom-radio">
                                  <input
                                    :id="'isVatPayerFalse-' + p.id"
                                    :checked="priceList.prices[p.id+''].isVatPayer === 'false'"
                                    type="radio"
                                    :name="'isVatPayer-' + p.id"
                                    class="custom-control-input"
                                    value="false"
                                    @change="updateVatPayer(p.id+'', 'false')"
                                  >
                                  <label
                                    :for="'isVatPayerFalse-' + p.id"
                                    class="custom-control-label"
                                  >
                                    ƏDV ödəyicisi deyiləm
                                  </label>
                                </div>
                              </div>
                              <small
                                v-if="priceList.prices[p.id+''].isVatPayer === undefined"
                                class="text-danger"
                              >
                                Seçim edin
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mb-3">
                      <label>
                        {{ $t('request.texnikiSpesifikasiya') }}
                      </label>
                      <textarea
                        v-model="priceList.techSpecs[p.id]"
                        class="form-control"
                        name="techSpecification"
                        cols="4"
                        :placeholder="$t('request.tklifEtdiyinizMhsulVXidmtinXsusiSpesifikasiyasVars')"
                      />
                      <div>
                        <label class="mt-3">
                          {{ $t('request.fayllar') }}
                        </label>
                        <div class="row">
                          <div
                            class="col-2 mb-3 card bg-primary"
                            style="cursor: pointer"
                            @click.prevent="selectTechSpecsPhoto(p.id)"
                          >
                            <div class="card-body d-flex text-white w-100 justify-content-center align-items-center ">
                              {{ $t('newAUCRequest.ykl') }}
                            </div>
                          </div>
                          <div
                            v-for="(f,i) in priceList.techSpecsFiles[p.id]"
                            :key="f"
                            class="col-4"
                          >
                            <div class="position-relative">
                              <a
                                v-if="isPhoto(f)"
                                target="_blank"
                                :href="getPhoto(f,'')"
                              >
                                <img
                                  :src="getPhoto(f,'')"
                                  class="img-thumbnail"
                                  style="max-height: 200px;"
                                  :alt="$t('newRequest.requestPhoto')"
                                >
                              </a>
                              <a
                                v-else
                                target="_blank"
                                :href="getPhoto(f,'')"
                                class="card border border-dark"
                              >
                                <div
                                  class="card-body d-flex text-dark w-100 justify-content-center align-items-center "
                                >
                                  {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.split('.').pop() }}
                                </div>
                              </a>

                              <div
                                style="position: absolute; top:0 ; right:0; padding: 10px; background: rgba(0,0,0,0.7);"
                              >
                                <div @click="deleteTechSpecsFile(p.id, i)">
                                  <feather
                                    style="color: white;"
                                    type="trash"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="mt-2 ">
                          <div
                            v-if="uploadProgress >0 && uploadProgress <100"
                            class="progress"
                          >
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated"
                              role="progressbar"
                              aria-valuenow="75"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              :style="{width: `${uploadProgress}%`}"
                            />
                          </div>
                        </div>
                        <span class="text-danger small">{{ $t('request.techSpecMinFile') }}</span>
                      </div>
                    </div>
                    <div class="mb-3">
                      <!-- Checkbox for Alternative Offer -->
                      <div
                        v-if="requestExtras.alternativeRequired"
                        class="form-check"
                      >
                        <input
                          :id="'alternativeOfferCheckbox-' + p.id"
                          v-model="priceList.prices[p.id+''].hasAlternativeOffer"
                          type="checkbox"
                          class="form-check-input"
                        >
                        <label
                          :for="'alternativeOfferCheckbox-' + p.id"
                          class="form-check-label"
                        >
                          Tələbə uyğun alternativ təklif ver
                        </label>
                      </div>

                      <!-- Alternative Offer Fields (Visible only when checkbox is checked) -->
                      <div
                        v-if="priceList.prices[p.id+''].hasAlternativeOffer"
                        class="mt-3"
                      >
                        <label>Məhsulun adı</label>
                        <input
                          v-model="priceList.prices[p.id+''].alternativeOffer.productName"
                          type="text"
                          class="form-control mb-3"
                          placeholder="Məhsulun adı"
                        >

                        <label>1 ədəd üçün toplam qiymət</label>
                        <div class="row align-items-end">
                          <div class="col-3 text-center">
                            <label :for="'altPriceInput-' + p.id">Məhsul qiyməti</label>
                            <input
                              :id="'altPriceInput-' + p.id"
                              v-model.number="priceList.prices[p.id+''].alternativeOffer.price"
                              type="number"
                              step="0.01"
                              class="form-control"
                              required
                            >
                          </div>
                          <div class="col-1 text-center">
                            <span
                              class="badge badge-pill badge-danger"
                              style="font-size: 1.1rem;"
                            >x{{ p.count }}</span>
                          </div>

                          <div class="col-2 text-center">
                            <label :for="'altVatInput-' + p.id">ƏDV faizi</label>
                            <input
                              :id="'altVatInput-' + p.id"
                              :value="priceList.prices[p.id+''].alternativeOffer.isVatPayer === 'true'
                                ? (priceList.prices[p.id+''].alternativeOffer.price * 0.18).toFixed(2)*p.count
                                : 0"
                              type="text"
                              class="form-control"
                              disabled
                            >
                          </div>

                          <div class="col-2 text-center">
                            <label :for="'altTotalInput-' + p.id">Toplam qiymət</label>
                            <input
                              :id="'altTotalInput-' + p.id"
                              :value="priceList.prices[p.id+''].alternativeOffer.isVatPayer === 'true'
                                ? (priceList.prices[p.id+''].alternativeOffer.price +
                                  parseFloat((priceList.prices[p.id+''].alternativeOffer.price * 0.18).toFixed(2)))*p.count
                                : priceList.prices[p.id+''].alternativeOffer.price *p.count"
                              type="text"
                              disabled
                              class="form-control"
                              required
                            >
                          </div>
                          <div class="col-3 mt-2">
                            <div class="radio radio-primary">
                              <div class="custom-control custom-radio">
                                <input
                                  :id="'altVatPayerTrue-' + p.id"
                                  type="radio"
                                  :name="'altVatPayer-' + p.id"
                                  class="custom-control-input"
                                  value="true"
                                  :checked="priceList.prices[p.id+''].alternativeOffer.isVatPayer === 'true'"
                                  required
                                  @change="updateAltVatPayer(p.id+'', 'true')"
                                >
                                <label
                                  class="custom-control-label"
                                  :for="'altVatPayerTrue-' + p.id"
                                >ƏDV ödəyicisiyəm</label>
                              </div>
                            </div>
                            <div class="radio radio-primary">
                              <div class="custom-control custom-radio">
                                <input
                                  :id="'altVatPayerFalse-' + p.id"
                                  type="radio"
                                  :name="'altVatPayer-' + p.id"
                                  class="custom-control-input"
                                  value="false"
                                  :checked="priceList.prices[p.id+''].alternativeOffer.isVatPayer === 'false'"
                                  @change="updateAltVatPayer(p.id+'', 'false')"
                                >
                                <label
                                  class="custom-control-label"
                                  :for="'altVatPayerFalse-' + p.id"
                                >ƏDV ödəyicisi deyiləm</label>
                              </div>
                            </div>
                            <small
                              v-if="priceList.prices[p.id+''].alternativeOffer.isVatPayer === undefined"
                              class="text-danger"
                            >
                              Seçim edin
                            </small>
                          </div>
                        </div>

                        <!-- Alternative Offer VAT Payer Radios -->

                        <label class="mt-3">Texniki Spesifikasiya</label>
                        <textarea
                          v-model="priceList.prices[p.id+''].alternativeOffer.techSpecs"
                          class="form-control"
                          rows="4"
                          placeholder="Alternativ məhsulun xüsusi spesifikasiyası"
                        />
                        <div>
                          <label class="mt-3">
                            {{ $t('request.fayllar') }}
                          </label>
                          <div class="row">
                            <div
                              class="col-2 mb-3 card bg-primary"
                              style="cursor: pointer"
                              @click.prevent="selectTechSpecsAlternativePhoto(p.id)"
                            >
                              <div class="card-body d-flex text-white w-100 justify-content-center align-items-center ">
                                {{ $t('newAUCRequest.ykl') }}
                              </div>
                            </div>
                            <div
                              v-for="(f,i) in priceList.techSpecsFilesAlternative[p.id]"
                              :key="f"
                              class="col-4"
                            >
                              <div class="position-relative">
                                <a
                                  v-if="isPhoto(f)"
                                  target="_blank"
                                  :href="getPhoto(f,'')"
                                >
                                  <img
                                    :src="getPhoto(f,'')"
                                    class="img-thumbnail"
                                    style="max-height: 200px;"
                                    :alt="$t('newRequest.requestPhoto')"
                                  >
                                </a>
                                <a
                                  v-else
                                  target="_blank"
                                  :href="getPhoto(f,'')"
                                  class="card border border-dark"
                                >
                                  <div
                                    class="card-body d-flex text-dark w-100 justify-content-center align-items-center "
                                  >
                                    {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.split('.').pop() }}
                                  </div>
                                </a>
                                <div
                                  style="position: absolute; top:0 ; right:0; padding: 10px; background: rgba(0,0,0,0.7);"
                                >
                                  <div @click="deleteTechSpecsAlternativeFile(p.id, i)">
                                    <feather
                                      style="color: white;"
                                      type="trash"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="mt-2">
                            <div
                              v-if="uploadProgress >0 && uploadProgress <100"
                              class="progress"
                            >
                              <div
                                class="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                aria-valuenow="75"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                :style="{width: `${uploadProgress}%`}"
                              />
                            </div>
                          </div>
                          <span class="text-danger small">{{ $t('request.techSpecMinFile') }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <hr class="my-4"> <!-- Horizontal line as a separator -->
                <h5 class="text-center mb-3">
                  {{ $t('newAUCRequest.specialRequirements') }}
                </h5> <!-- Centered label for requirements -->
                <div
                  v-for="(req, reqIndex) in p.requirements"
                  :key="`req-${reqIndex}`"
                  class="row mb-3"
                >
                  <!-- Requirement text on the left -->
                  <div class="col-md-6">
                    <label>{{ `${reqIndex + 1}.${req.requirement}` }}</label>
                  </div>
                  <!-- Input field for requirement detail on the right -->
                  <div class="col-md-5">
                    <input
                      v-model="priceList.requirements[p.id][req.id]"
                      type="text"
                      :required="req.mandatory"
                      class="form-control"
                      @invalid="setCustomError"
                      @input="clearCustomError"
                    >
                  </div>
                  <div
                    v-if="req.mandatory"
                    class="col-md-1"
                  >
                    <span
                      class="text-danger"
                    >*</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="container mt-4">
              <!-- Zəruri Tələblər -->
              <h5 class="font-weight-bold mb-4 text-primary">
                Zəruri Tələblər
              </h5>

              <!-- Delivery Time -->
              <div class="card mb-4 shadow-sm">
                <div
                  v-if="requestExtras.deliveryNeeded==='true'"
                  class="card-body"
                >
                  <h4
                    v-if="requestExtras.deliveryTimeNeeded==='true'"
                    class="font-weight-bold mb-2"
                  >
                    Çatdırılma müddətini seçin
                  </h4>
                  <div class="form-row align-items-center">
                    <div
                      v-if="requestExtras.deliveryTimeNeeded==='true'"
                      class="col-md-6"
                    >
                      <div class="d-flex align-items-center">
                        <input
                          v-model.number="priceList.deliveryDays"
                          type="number"
                          class="form-control mr-2"
                          :disabled="priceList.deliveryOption"
                          placeholder="0"
                          min="1"
                          required
                          style="max-width: 100px"
                        >
                        <span class="text-muted">Gün ərzində</span>
                      </div>
                    </div>
                    <div class="col-md-6 mt-3 mt-md-0">
                      <div class="checkbox checkbox-secondary checkbox-animated">
                        <input
                          id="noDelivery"
                          v-model="priceList.deliveryOption"
                          type="checkbox"
                          class="form-check-input"
                        >
                        <label
                          for="noDelivery"
                          class="form-check-label text-muted"
                        >
                          Çatdırılma yoxdur
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Incoterms Dropdown -->
              <div
                v-if="priceList.deliveryOption!==true && requestExtras.deliveryNeeded==='true'"
                class="card mb-4 shadow-sm"
              >
                <div class="card-body">
                  <h4 class="font-weight-bold mb-2">
                    Çatdırılma şərtlərini seçin
                  </h4>
                  <select
                    v-model="priceList.incoterms"
                    class="form-control"
                    required
                  >
                    <option
                      v-for="i in inctermsList"
                      :key="i"
                      :value="i"
                    >
                      {{ i }}
                    </option>
                  </select>
                  <small
                    v-if="priceList.incoterms ==='DDP'"
                    class="form-text text-muted mt-1"
                  >{{ requestExtras.deliveryAddress }}</small>
                </div>
              </div>

              <!-- Payment Terms -->
              <div
                v-if="requestExtras.paymentRequired==='true'"
                class="card mb-4 shadow-sm"
              >
                <div class="card-body">
                  <h4 class="font-weight-bold mb-2">
                    Ödəniş şərtləri
                  </h4>
                  <div class="radio radio-primary  ">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        id="paymentAfter"
                        v-model="priceList.paymentOption"
                        name="paymentOption"
                        type="radio"
                        class="custom-control-input"
                        value="afterDelivery"
                        required
                      >
                      <label
                        for="paymentAfter"
                        class="custom-control-label"
                      >Təhvildən sonra 30 gün ərzində 100% ödəniş</label>
                    </div>
                  </div>
                  <div class="radio radio-primary  ">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        id="paymentBefore"
                        v-model="priceList.paymentOption"
                        name="paymentOption"
                        type="radio"
                        class="custom-control-input"
                        value="beforeDelivery"
                      >
                      <label
                        for="paymentBefore"
                        class="custom-control-label"
                      >Təhvildən əvvəl öncədən 100% ödəniş</label>
                    </div>
                  </div>
                  <div class="radio radio-primary">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        id="paymentAdvance"
                        v-model="priceList.paymentOption"
                        name="paymentOption"
                        type="radio"
                        class="custom-control-input"
                        value="advancePayment"
                      >
                      <label
                        for="paymentAdvance"
                        class="custom-control-label"
                      >Avans ödəniş (şərh bölməsində rəqəmlə, %-lə göstərilsin)</label>
                    </div>
                  </div>
                  <div v-if="priceList.paymentOption==='advancePayment' ">
                    <textarea
                      v-model="priceList.paymentComment"
                      class="form-control"
                      placeholder="Öz təklifinizi qeyd edin"
                      rows="2"
                    />
                    <span
                      v-if="priceList.paymentComment?.length<10"
                    >Avans qeydlərini yazın.Minimum 10 simvol olmalıdır </span>
                  </div>
                </div>
              </div>

              <!-- Warranty Terms -->
              <div
                v-if="requestExtras.guarantyTime==='true'"
                class="card mb-4 shadow-sm"
              >
                <div class="card-body">
                  <h4 class="font-weight-bold  mb-2">
                    Zəmanət şərtləri
                  </h4>
                  <div class="form-row align-items-center">
                    <div class="col-md-6">
                      <div class="d-flex align-items-center">
                        <input
                          v-model.number="priceList.warrantyPeriod"
                          type="number"
                          class="form-control mr-2"
                          :disabled="priceList.warrantyOption"
                          :required="!priceList.warrantyOption"
                          placeholder="0"
                          min="0"
                          style="max-width: 100px"
                        >
                        <span class="text-muted">AY</span>
                      </div>
                    </div>
                    <div class="col-md-6 mt-3 mt-md-0">
                      <div class="checkbox checkbox-secondary checkbox-animated">
                        <input
                          id="noWarranty"
                          v-model="priceList.warrantyOption"
                          type="checkbox"
                          class="form-check-input"
                        >
                        <label
                          for="noWarranty"
                          class="form-check-label text-muted"
                        >
                          Zəmanət verilmir
                        </label>
                      </div>
                    </div>
                  </div>
                  <textarea
                    v-model="priceList.warrantyComment"
                    class="form-control mt-3"
                    placeholder="Öz təklifinizi qeyd edin"
                    :required="priceList.warrantyPeriod>0"
                    rows="2"
                  />
                </div>
              </div>

              <!-- Manufacturer Country -->
              <div
                v-if="requestExtras.countryRequired==='true'"
                class="card mb-4 shadow-sm"
              >
                <div class="card-body">
                  <h4 class="font-weight-bold mb-2">
                    İstehsalçı ölkə
                  </h4>
                  <input
                    v-model="priceList.manufacturerCountry"
                    type="text"
                    required
                    class="form-control"
                    placeholder="Ölkə adı daxil edin"
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label>
                    {{ $t('request.tklifinEtibarllqTarixi') }}
                  </label>
                  <DatePicker
                    v-model="priceList.valid"
                    mode="dateTime"
                    :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                    is24hr
                    :minute-increment="15"
                    :min-date="minDeadline"
                    :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
                  >
                    <template #default="{ inputValue, inputEvents }">
                      <input
                        type="text"
                        class="form-control "
                        :value="inputValue"
                        placeholder=""
                        v-on="inputEvents"
                      >
                    </template>
                  </DatePicker>
                </div>
              </div>
              <div class="col-md-6">
                <label>
                  {{ $t('request.fayllar') }}
                </label>
                <div class="row">
                  <div
                    class="col-md-4 mb-3 card bg-primary"
                    style="cursor: pointer"
                    @click.prevent="selectPQTOfferPhoto()"
                  >
                    <div class="card-body d-flex text-white w-100 justify-content-center align-items-center ">
                      {{ $t('newAUCRequest.ykl') }}
                    </div>
                  </div>

                  <div
                    v-for="(f,i) in priceList.files"
                    :key="f"
                    class="col-md-4 mb-3"
                  >
                    <div class="position-relative">
                      <a
                        v-if="isPhoto(f)"
                        target="_blank"
                        :href="getPhoto(f,'')"
                      >
                        <img
                          :src="getPhoto(f,'thumbnailCropped')"
                          class="img-thumbnail"
                          style="max-height: 200px;"
                          :alt="$t('newRequest.requestPhoto')"
                        >
                      </a>
                      <a
                        v-else
                        target="_blank"
                        :href="getPhoto(f,'')"
                        class="card border border-dark "
                        style="height: 100%"
                      >
                        <div class="card-body d-flex text-dark w-100 justify-content-center align-items-center ">
                          {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.split('.').pop() }}
                        </div>
                      </a>

                      <div
                        style="position: absolute; top:0 ; right:0; padding: 10px; background: rgba(0,0,0,0.7);"
                      >
                        <div @click="deletePQTOfferFile(i)">
                          <feather
                            style="color: white;"
                            type="trash"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-2 ">
                  <div
                    v-if="uploadProgress >0 && uploadProgress <100"
                    class="progress"
                  >
                    <div
                      class="progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      aria-valuenow="75"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      :style="{width: `${uploadProgress}%`}"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="my-3 text-danger">
              {{ $t('request.tklifVermkNMddtBitnQdrTkrarTklifGndrBilrsiniz') }} <br>
              {{ $t('request.tklifinizNUyunOlduuHaldaSatnalmaMzakiryBalayaBilrB') }} <br>
              {{ $t('request.mhsulBardQeyriUyunInformasiyaQeydinGrSatnalmaTrfin') }}
            </div>
            <div class="my-3">
              <button
                class="btn btn-success"
                type="submit"
              >
                {{ $t('request.tklifGndr') }}
              </button>
            </div>
          </form>
        </div>
        <div v-if="request.requestType ==='LOG'">
          <form @submit.prevent="sendLogisticPriceOffer">
            <div
              v-for="p in products"
              :key="p.id"
            >
              <div class="row">
                <div class="col-12">
                  <strong>{{ p.name }}</strong> <br>
                  {{ p.count }} {{ p.unit }}
                </div>
                <div class="col-12">
                  <div
                    v-for="t in requestExtras.types.split(',')"
                    :key="t"
                    class="ribbon-wrapper my-4 border rounded"
                  >
                    <div class="ribbon ribbon-warning ribbon-space-bottom">
                      {{ getDeliveryTypeName(t) }}
                    </div>

                    <div class="row m-2">
                      <div class="col-md-4">
                        <label>{{ $t('aucPrices.qiymt') }}</label>
                        <div class="input-group">
                          <input
                            v-model.number="logisticPriceList.prices[p.id+''][t].price"
                            type="number"
                            class="form-control"
                            required
                          >
                          <div class="input-group-text">
                            {{ $t('newAUCRequest.azn') }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label>{{ $t('request.mddt') }}</label>
                        <div class="input-group">
                          <input
                            v-model.number="logisticPriceList.prices[p.id+''][t].day"
                            type="number"
                            class="form-control"
                            required
                          >
                          <div class="input-group-text">
                            {{ $t('request.gn') }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label>{{ $t('request.dv') }}</label>
                        <select
                          v-model.number="logisticPriceList.prices[p.id+''][t].tax"
                          class="form-control"
                          required
                        >
                          <option value="0">
                            {{ $t('request.dvDaxil') }}
                          </option>
                          <option value="1">
                            {{ $t('request.dvXaric') }}
                          </option>
                          <option value="2">
                            {{ $t('request.sadldirilmiVergiDyicisi') }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr>
            </div>

            <div class="my-3">
              <button
                class="btn btn-success"
                type="submit"
              >
                {{ $t('request.tklifGndr') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-company-rate-statists"
      :title="`${getProfileName(openCompanyRatingStatisticPopupProfile)} profili`"
      ok-only
      ok-title="bağla"
      class="theme-modal"
    >
      <CompanyRateStatistics
        v-if="openCompanyRatingStatisticPopup>0"
        :show-company="true"
        :company-id="openCompanyRatingStatisticPopup"
        :profile-type="openCompanyRatingStatisticPopupProfile"
      />
    </b-modal>

    <b-modal
      id="modal-coworker"
      :title="`${$t('request.soruNzartisi')}`"
      hide-footer
      class="theme-modal"
    >
      <div
        v-if="companyUsers.length<1"
        class="alert alert-warning"
      >
        {{ $t('request.nzartiTyinEdilBilckIstifadiYoxdur') }}
      </div>

      <div v-else>
        <div
          v-for="user in companyUsers"
          :key="user.id"
          class="p-3"
        >
          <input
            :id="`rcw_${user.id}`"
            v-model="selectedCoWorker"
            class="form-check-input"
            type="radio"
            name="coworker"
            :value="user.user.id"
          >
          <label
            class="form-check-label"
            :for="`rcw_${user.id}`"
          >
            <span>{{ user.user.name }} {{ user.user.surname }}</span> <br>
            <span class="text-secondary">{{ user.position }}</span>
          </label>
        </div>

        <div
          v-if="selectedCoWorker"
          class="mt-3"
        >
          <button
            class="btn btn-sm btn-primary"
            @click="setCoWorker"
          >
            {{ $t('request.nzartiTyinEt') }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  createPollAnswer,
  createProduct,
  deletePollAnswer,
  deleteProduct,
  deleteRequest,
  editProduct,
  exportRequestResult,
  favoriteRequest,
  getCompanyUsers,
  getRequestDetails,
  getRequestPrices,
  getRequestUpdates,
  getRequestWinners,
  prolongRequest,
  publishRequest,
  reportComment,
  sendComment,
  sendPQTOffer,
  setRequestCoWorker,
  startConversation,
  submitPollAnswer,
  unFavoriteRequest,
  upload,
  userSetAccount
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {
  buildLongId,
  getCompanyFormat,
  getDeliveryTypeName,
  getPhoto,
  getProfileName,
  requestName,
  showLimitExceedPopup
} from "@/repositories/Utils";
import RequestCountdown from "@/pages/scc/request/RequestCountdown.vue";
import RequestParticipants from "@/pages/scc/request/RequestParticipants.vue";
import RequestConversations from "@/pages/scc/request/RequestConversations.vue";
import StarRatingView from "@/pages/scc/utils/StarRatingView.vue";
import CompanyRateStatistics from "@/pages/scc/company/CompanyRateStatistics.vue";
import RequestFAQ from "@/pages/scc/request/RequestFAQ.vue";
import OfferExtrasView from "@/components/parts/OfferExtrasView.vue";
import LogisticExtrasView from "@/components/parts/LogisticExtrasView.vue";
import TRSExtrasView from "@/components/parts/TRSExtrasView.vue";
import TRKExtrasView from "@/components/parts/TRKExtrasView.vue";
import PQTExtrasView from "@/components/parts/PQTExtrasView.vue";
import PQTOffersView from "@/pages/scc/request/PQTOffersView.vue";
import RFQOffersView from "@/pages/scc/request/RFQOffersView.vue";
import AUCPrices from "@/pages/scc/request/AUCPrices.vue";
import RequestCloseFlow from "@/pages/scc/request/RequestCloseFlow.vue";
import MyPQTOffer from "@/pages/scc/request/MyPQTOffer.vue";
import MyRFQOffer from "@/pages/scc/request/MyRFQOffer.vue";
import MyLOGOffer from "@/pages/scc/request/MyLOGOffer.vue";
import MyPOLVote from "@/pages/scc/request/MyPOLVote.vue";
import CommentView from "@/pages/scc/request/CommentView.vue";
import RequestCanNotCommentOfferView from "@/pages/scc/request/RequestCanNotCommentOfferView.vue";
import RequestLogisticProduct from "@/pages/scc/request/RequestLogisticProduct.vue";
import dayjs from "dayjs";
import moment from "moment/moment";
import Vue from "vue";
import {i18n} from "@/main";

export default {
  components: {
    RequestLogisticProduct,
    RequestCanNotCommentOfferView,
    CommentView,
    MyPOLVote,
    MyLOGOffer,
    MyRFQOffer,
    MyPQTOffer,
    RequestCloseFlow,
    AUCPrices,
    RFQOffersView,
    PQTOffersView,
    PQTExtrasView,
    TRKExtrasView,
    TRSExtrasView,
    LogisticExtrasView,
    OfferExtrasView,
    RequestFAQ,
    CompanyRateStatistics, StarRatingView, RequestConversations, RequestParticipants, RequestCountdown
  },
  data() {
    return {
      isPublishing: false,
      inctermsList: ["EXW", "FOB", "CIF", "FCA", "DPU", "CFR", "CIP", "DAP", "DDP"],
      fullUrl: '',
      mediaBase: mediaBase,
      request: null,
      sectors: [],
      isFavorite: false,
      products: [],
      files: [],
      requestUser: null,
      requestPrices: [],
      pollAnswers: [],
      commentCount: 0,
      comments: [],
      offers: [],
      conversations: [],
      commentText: '',
      privateComment: false,
      updateTimer: null,
      currentTime: '',

      requestWinners: [],


      showProlongForm: '',
      prolongDate: '',

      canOfferStatus: '',
      canCommentStatus: '',

      priceList: {
        "meta": {"version": 2},
        "prices": {},
        "totalPrices": {},
        "taxIncluded": {},
        "alternative": {},
        "techSpecs": {},
        techSpecsFiles: {},
        techSpecsFilesAlternative: {},
        "requirements": {},
        manufactererCountry: "",
        deliveryDays: 0,
        deliveryOption: false,
        paymentOption: '',
        warrantyPeriod: undefined,
        warrantyOption: false,
        warrantyComment: '',
        files: [],
        valid: '',
        techSpecification: '',
        payment: '',
        delivery: ''
      },
      logisticPriceList: {"prices": {}},
      newLogisticProduct: {},
      addPollAnswerOpen: false,
      newPollAnswerText: '',
      newRFQProduct: {},
      photoTarget: '',
      photoTargetProductId: 0,
      uploadProgress: 0,
      reportingCommentId: 0,
      reportingCommentReason: '',
      companyUserCommented: '',
      place: 0,
      productUnits: this.$t("productUnits"),
      serviceUnits: this.$t("serviceUnits"),
      loadUnits: this.$t("loadUnits"),

      selectedPollAnswerList: [],
      selectedPollAnswer: 0,
      pollOwnAnswers: '',
      networks: [
        {
          name: 'facebook',
          iconClass: 'fa fa-fw fa-facebook-square',
          btnClass: 'btn-light-primary',
          translationKey: 'request.facebook'
        },
        {
          name: 'email',
          iconClass: 'fa fa-fw fa-at',
          btnClass: 'btn-light-primary',
          translationKey: 'request.emailGndr'
        },
        {
          name: 'linkedIn',
          iconClass: 'fa fa-fw fa-linkedin',
          btnClass: 'btn-light-primary',
          translationKey: 'companyProfile.linkedin2' // Assuming you don't have a translation key for LinkedIn
        },
        {
          name: 'telegram',
          iconClass: 'fa fa-fw fa-telegram',
          btnClass: 'btn-light-info',
          translationKey: 'request.telegram'
        },
        {
          name: 'whatsapp',
          iconClass: 'fa fa-fw fa-whatsapp',
          btnClass: 'btn-light-success',
          translationKey: 'companyProfile.whatsapp'
        }
      ],
      openCompanyRatingStatisticPopup: 0,
      openCompanyRatingStatisticPopupProfile: '',

      totalPriceProducts: [],
      alternativeProducts: [],


      isCoWorker: false,
      coWorker: null,
      coWorkerPosition: null,
      selectedCoWorker: null,
      companyUsers: [],
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      profile: state => state.auth.profile,
      sessionType: state => state.auth.sessionType,
      position: state => state.auth.position,
    }),

    requestName() {
      return requestName(this.request);
    },

    requestExtras() {
      if (this.request) {

        try {
          return JSON.parse(this.request.extras);
        } catch (e) {
          console.error(e);
        }
      }
      return {};
    },

    isMyRequest() {
      return this.user.id === this.request.user.id
          && this.company.id === this.request.company.id

    },
    canVote() {
      if (!this.request.personalAllowed && this.company.legalForm === 'PERSONAL') {
        return false;
      }

      return this.request.status === 'ACTIVE' && this.user.id !== this.request.user.id;
    },
    totalAnswerCount() {
      let total = 0;
      this.pollAnswers.forEach(a => {
        total += a.selected;
      })
      return total;
    },
    minDeadline() {
      return dayjs().add(1, "day").format("YYYY-MM-D");
    }
  },
  watch: {
    'priceList.deliveryOption'(newVal) {
      if (newVal === true) {
        this.priceList.deliveryDays = undefined;
      }
    },
    'priceList.warrantyOption'(newVal) {

      if (newVal === true) {
        this.priceList.warrantyPeriod = undefined;

      }
    },
    "$route"() {
      this.getRequest();
    },
    pollOwnAnswers() {
      if (this.requestExtras.multiSelect < 1) {
        this.selectedPollAnswer = 0;
      }
    }
  },
  mounted() {
    this.getRequest();

    this.fullUrl = window.location.href;

    this.updateTimer = setInterval(() => {
      this.getUpdates();
    }, 3000)

  },
  beforeDestroy() {
    if (this.updateTimer) {
      clearInterval(this.updateTimer);
    }
  },
  methods: {
    updateAltVatPayer(productId, value) {
      // Ensure the alternativeOffer object exists
      if (!this.priceList.prices[productId].alternativeOffer) {
        this.$set(this.priceList.prices[productId], 'alternativeOffer', {});
      }
      // Update the isVatPayer property
      this.priceList.prices[productId].alternativeOffer.isVatPayer = value;
      // Force reactivity by reassigning the whole prices object
      this.priceList.prices = {...this.priceList.prices};
    },
    updateVatPayer(productId, value) {
      // Directly update the nested property
      this.priceList.prices[productId].isVatPayer = value;
      // Force reactivity by replacing the entire prices object
      this.priceList.prices = {...this.priceList.prices};
    },
    setCustomError(event) {
      event.target.setCustomValidity("Xananı doldurmaq vacibdir"); // Set your custom message
    },
    clearCustomError(event) {
      event.target.setCustomValidity(""); // Clear the custom message
    },


    printSection(sectionId) {
      const section = document.getElementById(sectionId).outerHTML;
      const printWindow = window.open('', '', 'width=800,height=600');

      // 1. Gather styles from the main document
      const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
          .map(style => style.outerHTML)
          .join('');
      const currentUrl = window.location.href;
      const qrCodeUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=' + encodeURIComponent(currentUrl);
      // 2. Construct the new window’s HTML
      const printContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Print Preview</title>
        ${styles}
      </head>
      <body>
        <!-- Example images (logo + QR). Insert your own URLs/base64. -->
        <div style="text-align: center; margin-bottom: 20px;">
          <img
            src="https://filetest.scc.az/request/big_logo.png"
            alt="Logo"
            style="max-width: 200px; display: block; margin: 0 auto;"
          />
          <div style="margin-top: 10px;">
            <img
              src="${qrCodeUrl}"
              alt="QR Code"
              style="width: 100px; height: 100px;"
            />
          </div>
        </div>

        <!-- The main content you want to print -->
        ${section}
      </body>
    </html>
  `;

      // 3. Write the HTML
      printWindow.document.write(printContent);
      printWindow.document.close(); // End writing

      // 4. Wait for images to load in the new window
      const images = printWindow.document.getElementsByTagName('img');
      let loadedCount = 0;

      // If there are no images, just print immediately
      if (images.length === 0) {
        finishPrinting();
      } else {
        // Attach onload to each image
        for (let i = 0; i < images.length; i++) {
          images[i].onload = () => {
            loadedCount++;
            if (loadedCount === images.length) {
              // All images have loaded
              finishPrinting();
            }
          };
          // Handle errors or missing images
          images[i].onerror = () => {
            loadedCount++;
            if (loadedCount === images.length) {
              finishPrinting();
            }
          };
        }
      }

      // Helper to finalize print
      function finishPrinting() {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }
    },
    i18n() {
      return i18n
    },
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getRequest() {
      getRequestDetails(this.token, this.$route.params['id']).then(data => {
        if (data.code === 200) {

          this.fullUrl = window.location.href;

          this.request = data.request;
          this.sectors = data.sectors;
          this.products = data.products;
          this.place = data.place;

          this.files = data.files;
          this.requestUser = data.requestUser;
          this.pollAnswers = data.pollAnswers;
          this.commentCount = data.commentCount;
          this.conversations = data.conversations;
          this.comments = data.comments;
          this.offers = data.offers;
          this.companyUserCommented = data.companyUserCommented;
          this.isFavorite = data.isFavorite;
          this.isCoWorker = data.isCoWorker;
          this.coWorker = data.coWorker;
          this.coWorkerPosition = data.coWorkerPosition;
          this.currentTime = data.currentTime;
          this.canOfferStatus = data.canOffer;
          this.canCommentStatus = data.canComment;
          this.products.forEach(p => {
            try {
              p.extraJson = JSON.parse(p.extras);
            } catch (e) {

              p.extraJson = {};
            }
          })

          if (data.request.requestType === 'RFQ' || data.request.requestType === 'PQT') {
            data.products.forEach((p) => {
              // Always define a default shape so Vue never sees "undefined"
              this.$set(this.priceList.prices, p.id + '', {
                price: '',
                hasAlternativeOffer: false,
                alternativeOffer: {
                  productName: '',
                  price: null,
                  reason: '',
                  techSpecs: '',
                  isVatPayer: undefined
                }
              });
              this.priceList.taxIncluded[p.id + ""] = -1;
            });
          } else if (data.request.requestType === 'LOG') {
            data.products.forEach((p) => {
              this.logisticPriceList.prices[p.id + ""] = {};
              this.requestExtras.types.split(',').forEach(t => {
                this.logisticPriceList.prices[p.id + ""][t] = {
                  price: '', tax: 0, day: ''
                };
              })

            });
          }

          if (['AUC', 'REV'].indexOf(data.request.requestType) > -1) {

            getRequestPrices(this.token, data.request.id).then(list => {
              this.requestPrices = list;
            })

          }
          if (['AUC', 'REV', 'PQT', 'RFQ', 'RFI'].indexOf(data.request.requestType) > -1) {

              getRequestWinners(this.token, data.request.id).then(list => {
              this.requestWinners = list;
            });
          }
          this.products.forEach(product => {
            if (this.offers.length > 0) {
              let parseElement = JSON.parse(this.offers[0].prices)['prices'];
              let extras = JSON.parse(this.offers[0].prices)['extras'];
              Vue.set(this.priceList.techSpecs, product.id, {});
              Vue.set(this.priceList.requirements, product.id, {});
              this.priceList.valid = extras.valid
              this.priceList.deliveryDays = extras.deliveryDays
              this.priceList.incoterms = extras.incoterms
              this.priceList.paymentOption = extras.paymentOption
              this.priceList.paymentComment = extras.paymentComment
              this.priceList.warrantyPeriod = extras.warrantyPeriod
              this.priceList.warrantyComment = extras.warrantyComment
              this.priceList.manufacturerCountry = extras.manufacturerCountry
              this.priceList.deliveryOption = extras.deliveryOption
              this.priceList.warrantyOption = extras.warrantyOption
              parseElement.forEach(req => {
                const alt = req.alternativeOffer || {};


                this.priceList.techSpecs[req.product] = req.techSpecification;
                this.priceList.techSpecsFiles[req.product] = req.techSpecsFiles;
                this.priceList.techSpecsFilesAlternative[req.product] = req.techSpecsFilesAlternative;
                this.priceList.prices[req.product] = req;
                this.priceList.prices[req.product] = {

                  ...req,
                  hasAlternativeOffer: req.alternativeOffer?.productName.length > 0,
                  alternativeOffer: {
                    productName: alt.productName || '',
                    price: alt.price || null,
                    reason: alt.reason || '',
                    techSpecs: alt.techSpecs || '',
                    isVatPayer: alt.isVatPayer || 'false'
                  }

                }
                if (!this.priceList.requirements[req.product]) {
                  Vue.set(this.priceList.requirements, req.product, {});
                }
                req.reqDetails.forEach(reqDetail => {
                  // Use Vue.set to ensure reactivity
                  Vue.set(
                      this.priceList.requirements[req.product],
                      reqDetail.id,
                      reqDetail.detail
                  );
                });
              })
            } else {
              Vue.set(this.priceList.requirements, product.id, {});
              product.requirements.forEach(req => {
                this.priceList.requirements[product.id][req.id] = ''; // Initialize with an empty string or default value
              });
            }
          });
        } else if (data.code === 403) {
          this.$router.push({name: 'changeAccount', query: {'next': `/dashboard/request/${this.$route.params['id']}`}});
        } else if (data.code === 404) {
          this.$swal({
            title: this.$t("general.notFound"),
            text: this.$t("general.requestNotFound"),
            icon: 'error'
          }).then(() => {
            this.$router.replace({name: 'welcome'});
          })
        } else if (data.code === 406) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: `${data.message} `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t("companyUserSectors.faliyytSahlrim"),
            cancelButtonText: this.$t("companyProfile.lvEt2")
          }).then((result) => {
            if (result.value) {
              this.$router.push({
                name: 'companyUserSectors',
                query: {'next': 'requestDetails', 'id': this.$route.params['id']}
              });
            } else {
              this.$router.go(-1);
            }
          })
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }
      })
    },
    getUpdates() {
      if (this.request && (['ACTIVE', 'WAITING', 'DISCUSSING', 'EXPIRED'].indexOf(this.request.status) > -1)) {

        if (['REV', 'AUC'].indexOf(this.request.requestType) > -1) {
          getRequestPrices(this.token, this.request.id).then(list => {
            this.requestPrices = list;
          });
        }
        let lastCommentId = 0;
        if (this.comments.length > 0) {
          lastCommentId = this.comments.at(-1).id;
        }
        getRequestUpdates(this.token, this.$route.params['id'], lastCommentId).then(data => {
          if (data.code === 200) {

            if (data.status !== this.request.status) {
              window.location.reload();
            }

            this.companyUserCommented = data.companyUserCommented;
            this.request.commentCount = data.commentCount;
            this.pollAnswers = data.pollAnswers;
            this.currentTime = data.currentTime

            this.comments = [
              ...this.comments,
              ...data.comments
            ];
          }
        })
      }
    },

    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getDeliveryTypeName(key) {
      return getDeliveryTypeName(key);
    },
    getProductPrices(productId) {

      let prices = [];

      this.comments.forEach(c => {

        let json = JSON.parse(c.commentData);

        if (json !== null) {

          if (json.hasOwnProperty("prices")) {
            //new version
            let alternative = null;
            if (json.hasOwnProperty("alternative") && json.alternative[productId]) {
              alternative = json.alternative[productId]
            }
            prices.push({
              id: c.id,
              user: c.user,
              company: c.company,
              position: c.position,
              profileType: c.profileType,
              price: json['prices'][productId + ""],
              alternative: alternative,
              taxIncluded: json['taxIncluded'][productId + ""]
            })

          } else {
            //old version

            prices.push({
              user: c.user,
              company: c.company,
              position: c.position,
              profileType: c.profileType,
              price: json['prices'][productId + ""],
              alternative: null,
              taxIncluded: -1
            })
          }
        }

      })

      return prices;

    },
    getProductPricesByCompany(companyId) {

      let prices = [];

      this.comments.forEach(c => {

        if (c.company.id === companyId) {
          let json = JSON.parse(c.commentData);

          this.products.forEach((p) => {

            if (json.hasOwnProperty("prices")) {
              //new version
              let alternative = null;
              if (json.hasOwnProperty("alternative") && json.alternative[p.id]) {
                alternative = json.alternative[p.id]
              }
              prices.push({
                id: p.id,
                product: p,
                price: json['prices'][p.id + ""],
                alternative: alternative,
                taxIncluded: json['taxIncluded'][p.id + ""]
              })

            } else {
              //old version

              prices.push({
                id: p.id,
                product: p,
                price: json['prices'][p.id + ""],
                alternative: null,
                taxIncluded: -1
              })
            }

          })
        }


      })

      return prices;

    },
    getTotalCompanyPrice(c) {

      let price = 0;
      let json = JSON.parse(c.commentData);

      this.products.forEach((p) => {
        if (json.hasOwnProperty("prices")) {
          //new version
          price += parseFloat(json['prices'][p.id + ""]);
        } else {
          //old version
          price += parseFloat(json[p.id + ""]);
        }
      })
      return price;

    },
    getLogisticPrices(productId) {

      let prices = [];

      this.comments.forEach(c => {

        let json = JSON.parse(c.commentData);


        prices.push({
          id: c.id,
          user: c.user,
          company: c.company,
          position: c.position,
          profileType: c.profileType,
          price: json['prices'][productId + ""],
        })

      })

      return prices;

    },
    getLogisticPricesByCompany(companyId) {

      let prices = [];

      this.comments.forEach(c => {

        if (c.company.id === companyId) {

          let json = JSON.parse(c.commentData);

          this.products.forEach(p => {
            prices.push({
              id: p.id,
              product: p,
              price: json['prices'][p.id + ""],
            })
          });
        }
      })

      return prices;

    },
    getProductById(id) {

      let prod;
      this.products.forEach(p => {
        if (p.id === parseInt(id)) {
          prod = p;
        }
      })

      return prod;

    },
    deletePQTOfferFile(index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.priceList.files.splice(index, 1);
      }
    },

    deleteTechSpecsFile(pId, index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.priceList.techSpecsFiles[pId].splice(index, 1);
      }
    },
    deleteTechSpecsAlternativeFile(pId, index) {
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.priceList.techSpecsFilesAlternative[pId].splice(index, 1);
      }
    },


    deleteProduct(id) {

      this.$swal({
        title: this.$t("general.dltConfirm"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t("general.delete"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
            if (result.value) {
              deleteProduct(this.token, id).then(data => {

                if (data.code === 200) {
                  this.getRequest();
                } else {
                  this.$swal({
                    title: `Error ${data.code}`,
                    text: `${data.message}`,
                    icon: 'error'
                  })
                }

              });
            }
          }
      );


    },
    deletePollAnswer(id) {

      this.$swal({
        title: this.$t("general.dltConfirm"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t("general.delete"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
            if (result.value) {
              deletePollAnswer(this.token, id).then(data => {

                if (data.code === 200) {
                  this.getRequest();
                } else {
                  this.$swal({
                    title: `Error ${data.code}`,
                    text: `${data.message}`,
                    icon: 'error'
                  })
                }

              });
            }
          }
      );


    },
    submitPollAnswer() {

      this.$swal({
        title: this.$t("general.cvbDyshMek"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t("body.gndr"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
            if (result.value) {

              let answerList = [];

              if (this.requestExtras.multiSelect > 0) {
                answerList = this.selectedPollAnswerList
              } else {
                if (this.selectedPollAnswer > 0) {
                  answerList = [this.selectedPollAnswer];
                }
              }

              if (this.requestExtras.ownVariant > 0) {
                if (answerList.length < 1 && this.pollOwnAnswers === '') {
                  this.$swal({
                    title: this.$t("generalModal.warningTitle"),
                    text: this.$t("general.cvbVrntScn"),
                    icon: 'warning'
                  });
                  return;
                }
              } else {
                if (answerList.length < 1) {
                  this.$swal({
                    title: this.$t("generalModal.warningTitle"),
                    text: this.$t("general.cvbVrntScn"),
                    icon: 'warning'
                  });
                  return;
                }
              }

              submitPollAnswer(this.token, this.request.id, answerList, this.pollOwnAnswers.split(',')).then(data => {

                if (data.code === 200) {
                  this.getRequest();
                } else {
                  this.$swal({
                    title: `Error ${data.code}`,
                    text: `${data.message}`,
                    icon: 'error'
                  })
                }

              });
            }
          }
      );


    },
    prolongRequest() {
      prolongRequest(this.token, this.request.id, this.prolongDate).then(data => {
        if (data.code === 200) {
          this.getRequest();
          this.prolongDate = '';
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      });
    },


    addLogisticProduct() {
      this.newLogisticProduct = {
        id: '',
        name: '',
        hsCode: '',
        count: '',
        countUnit: '',
        unit: '',
        package: '',
        width: '',
        height: '',
        length: '',
        sizeUnit: 'cm',
        weight: '',
        canBeStacked: 0,
        productType: 'basic',
        unCode: '',
        adrCode: '',
        temperature: '',
        temperatureUnit: 'C',
        notes: ''
      };
      this.$bvModal.show('modal-logistic-product-create');
    },
    addNewLogisticProduct() {

      let extras = {
        "version": "1.0.0",
        "hsCode": this.newLogisticProduct.hsCode,
        "packing": this.newLogisticProduct.package,
        "width": this.newLogisticProduct.width,
        "height": this.newLogisticProduct.height,
        "length": this.newLogisticProduct.length,
        "sizeUnit": this.newLogisticProduct.sizeUnit,
        "weight": this.newLogisticProduct.weight,
        "canBeStacked": this.newLogisticProduct.canBeStacked ? 1 : 0,
        "productType": this.newLogisticProduct.productType,
      }

      switch (extras['productType']) {
        case "dangerous":
          extras.un = this.newLogisticProduct.unCode;
          extras.adr = this.newLogisticProduct.adrCode;
          break;

        case "temperature":
          extras.temperature = this.newLogisticProduct.temperature;
          extras.temperatureUnit = this.newLogisticProduct.temperatureUnit;
          break;
      }

      if (this.newLogisticProduct.id > 0) {
        editProduct(this.token, this.newLogisticProduct.id, 'PRODUCT', this.newLogisticProduct.name, this.newLogisticProduct.count, null, this.newLogisticProduct.unit, this.newLogisticProduct.notes, JSON.stringify(extras)).then(data => {

          if (data.code === 200) {
            this.getRequest();
            this.$bvModal.hide('modal-logistic-product-create');
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }

        });
      } else {

        createProduct(this.token, this.request.id, 'PRODUCT', this.newLogisticProduct.name, this.newLogisticProduct.count, null, this.newLogisticProduct.unit, this.newLogisticProduct.notes, JSON.stringify(extras)).then(data => {

          if (data.code === 200) {
            this.getRequest();
            this.$bvModal.hide('modal-logistic-product-create');
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }

        });
      }

    },
    addRFQProduct() {

      this.$bvModal.show('modal-product-create');

      this.newRFQProduct = {
        name: '',
        count: '',
        countUnit: '',
        notes: '',
        photo: '',
        specialRequirements: []
      };
    },
    addNewRFQProduct() {
      let extras = {}
      if (this.newRFQProduct.id > 0) {
        editProduct(this.token, this.newRFQProduct.id, this.newRFQProduct.productType, this.newRFQProduct.name, this.newRFQProduct.count, this.newRFQProduct.photo, this.newRFQProduct.unit, this.newRFQProduct.notes, JSON.stringify(extras), this.newRFQProduct.specialRequirements).then(data => {

          if (data.code === 200) {
            this.getRequest();
            this.$bvModal.hide('modal-product-create');
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }

        });
      } else {

        createProduct(this.token, this.request.id, this.newRFQProduct.productType, this.newRFQProduct.name, this.newRFQProduct.count, this.newRFQProduct.photo, this.newRFQProduct.unit, this.newRFQProduct.notes, JSON.stringify(extras), this.newRFQProduct.specialRequirements).then(data => {

          if (data.code === 200) {
            this.getRequest();
            this.$bvModal.hide('modal-product-create');
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }

        });
      }

    },
    addNewPollAnswer() {


      createPollAnswer(this.token, this.request.id, this.newPollAnswerText).then(data => {

        if (data.code === 200) {
          this.getRequest();
          this.addPollAnswerOpen = false;
          this.newPollAnswerText = '';
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }

      });

    },

    editLogisticProduct(product) {
      let extras = JSON.parse(product.extras);
      this.$bvModal.show('modal-logistic-product-create');
      this.newLogisticProduct = {
        id: product.id,
        name: product.name,
        hsCode: extras.hsCode,
        count: product.count,
        countUnit: product.unit,
        unit: product.unit,
        package: extras.packing,
        width: extras.width,
        height: extras.height,
        length: extras.length,
        sizeUnit: extras.sizeUnit,
        weight: extras.weight,
        canBeStacked: extras.canBeStacked > 0,
        productType: extras.productType,
        unCode: extras.un,
        adrCode: extras.adr,
        temperature: extras.temperature,
        temperatureUnit: extras.temperatureUnit,
        notes: product.note
      };
    },

    editRFQProduct(product) {
      this.$bvModal.show('modal-product-create');
      this.newRFQProduct = {
        id: product.id,
        productType: product.productType,
        name: product.name,
        count: product.count,
        unit: product.unit,
        notes: product.note,
        photo: product.photo,
        specialRequirements: product.requirements
      };


    },

    startConversation(id) {

      startConversation(this.token, id).then(data => {

        if (data.code === 200) {
          this.$router.push(`/dashboard/conversation/${data.id}`);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }

      });
    },
    comment() {
      if (this.commentText) {
        sendComment(this.token, this.request.id, this.privateComment, 0, this.commentText, null, "TEXT", "{}").then(data => {
          if (data.code === 200) {
            this.commentText = '';
            this.getUpdates();
          } else if (data.code === 425) {
            showLimitExceedPopup(this.$swal, data.message, data.errorCode, false);
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    },
    sendPriceOffer() {
      sendComment(this.token, this.request.id, true, 0, '', null, "RFQ_PRICE", JSON.stringify(this.priceList)).then(data => {
        if (data.code === 200) {
          this.$bvModal.hide('modal-price-offer');
          this.getUpdates();
        } else if (data.code === 425) {
          showLimitExceedPopup(this.$swal, data.message, data.errorCode, false);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },
    sendPQTPriceOffer() {
      if (this.priceList.paymentOption === 'advancePayment' && (this.priceList.paymentComment === undefined || this.priceList.paymentComment.length < 10)) {
        this.$swal({
          title: "Avans qeydləri minimum 10 simvol olmalıdır",
          icon: 'error'
        });
        return;
      }
      sendPQTOffer(this.token, this.request.id, this.priceList).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("request.tklfnzQeydAlind"),
            icon: 'success'
          });

          this.$bvModal.hide('modal-price-offer');
          this.getRequest();

        } else if (data.code === 425) {
          showLimitExceedPopup(this.$swal, data.message, data.errorCode, false);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },
    sendLogisticPriceOffer() {
      sendComment(this.token, this.request.id, true, 0, '', null, "LOG_PRICE", JSON.stringify(this.logisticPriceList)).then(data => {
        if (data.code === 200) {

          this.$bvModal.hide('modal-price-offer');
          this.getUpdates();
        } else if (data.code === 425) {
          showLimitExceedPopup(this.$swal, data.message, data.errorCode, false);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },
    addToFavorites() {
      favoriteRequest(this.token, this.request.id).then(data => {
        if (data.code === 200) {
          this.isFavorite = true;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },
    deleteFromFavorites() {
      unFavoriteRequest(this.token, this.request.id).then(data => {
        if (data.code === 200) {
          this.isFavorite = false;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },
    async publishRequest() {
      if (this.isPublishing) return;

      this.isPublishing = true;

      publishRequest(this.token, this.request.id).then(data => {
        if (data.code === 200) {
          this.getRequest();
        } else if (data.code === 425) {
          showLimitExceedPopup(this.$swal, data.message, data.errorCode, true);
        } else if (data.code ===403){
          //TODO handle different errors by errorCodes
          console.log("403")
        } else {

          //todo handle different errors by errorCodes
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })

    },
    editRequest() {
      this.$router.push({name: 'editRequest', params: {id: this.request.id}});
    },
    addSpecialRequirementToProduct() {
      if (this.newRFQProduct.specialRequirements.length < 5) {
        this.newRFQProduct.specialRequirements.push({text: ''});
      } else {
        alert('You can only add up to 5 special requirements for each product.');
      }
    },
    removeSpecialRequirementFromProduct(index) {
      this.newRFQProduct.specialRequirements.splice(index, 1);
    },
    deleteRequest() {
      this.$swal({
        title: this.$t("generalModal.srgnSlmkStdynxEmin"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("generalModal.buttonDelete"),
        cancelButtonText: this.$t("generalModal.buttonCancel")
      }).then((result) => {
        if (result.value) {
          deleteRequest(this.token, this.request.id).then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.deleted"),
                text: this.$t("generalModal.successTitle"),
                icon: 'success'
              }).then(() => {
                this.$router.push({name: 'myRequests'});
              })
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          });
        }
      });
    },
    reportComment() {
      reportComment(this.token, this.reportingCommentId, this.reportingCommentReason).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("generalModal.skytnzQydAlnd"),
            icon: 'success'
          });
          this.$bvModal.hide('modal-comment-report');
        } else if (data.code === 409) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("generalModal.bIstfdcArtqSkyttmszn"),
            icon: 'warning'
          })
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },

    goToCreatorProfile() {
      userSetAccount(this.token, this.request.company.id, this.request.profileType, 'company').then(() => {
        window.location.reload();
      });
    },
    selectPQTOfferPhoto() {
      this.photoTarget = 'pqt';
      window.document.getElementById('fileInput').click();
    },

    selectTechSpecsPhoto(pId) {
      this.photoTarget = 'tech';
      this.photoTargetProductId = pId;
      window.document.getElementById('fileInput').click();
    },
    selectTechSpecsAlternativePhoto(pId) {
      this.photoTarget = 'techAlternative';
      this.photoTargetProductId = pId;
      window.document.getElementById('fileInput').click();
    },
    selectPhoto() {
      this.photoTarget = 'comment';
      window.document.getElementById('fileInput').click();
    },
    selectRFQPhoto() {
      this.photoTarget = 'rfq';
      window.document.getElementById('fileInput').click();
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'profilePhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {

                if (this.photoTarget === 'comment') {

                  sendComment(this.token, this.request.id, this.privateComment, 0, this.commentText, response.data.path, "TEXT", "{}").then(data => {
                    if (data.code === 200) {
                      this.commentText = '';
                      this.getUpdates();
                    } else if (data.code === 425) {
                      showLimitExceedPopup(this.$swal, data.message, data.errorCode, false);
                    } else {
                      this.$swal({
                        title: `Error ${data.code}`,
                        text: `${data.message}`,
                        icon: 'error'
                      })
                    }
                  })
                } else if (this.photoTarget === 'pqt') {
                  this.priceList.files.push(response.data.path);
                } else if (this.photoTarget === 'tech') {
                  if (!this.priceList.techSpecsFiles[this.photoTargetProductId])
                    Vue.set(this.priceList.techSpecsFiles, this.photoTargetProductId, []);
                  this.priceList.techSpecsFiles[this.photoTargetProductId].push(response.data.path)
                } else if (this.photoTarget === 'techAlternative') {
                  if (!this.priceList.techSpecsFilesAlternative[this.photoTargetProductId])
                    Vue.set(this.priceList.techSpecsFilesAlternative, this.photoTargetProductId, []);
                  this.priceList.techSpecsFilesAlternative[this.photoTargetProductId].push(response.data.path)
                } else {
                  this.newRFQProduct.photo = response.data.path;
                }

              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
              // Reset file input so selecting the same file again will trigger change event
              this.$refs.file.value = '';
            })
            .catch((e) => {

              this.progress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("request.cldNotUploadFile") + e,
                icon: 'error'
              });
              // Reset file input on error as well
              this.$refs.file.value = '';
            });
      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("request.photoUploadNotSpprtdBrowser"),
          icon: 'error'
        });
      }
    },
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },
    showUNPopup() {

      this.$swal({
        title: `UN Code`,
        text: this.$t("request.mhslnzUzrGlmsMSDS"),
        icon: 'warning'
      })
    },
    handleReportView(commentId) {
      this.reportingCommentId = commentId;
      this.$bvModal.show('modal-comment-report');
    },
    alternativeChanged(productId, value) {
      if (value.target.checked) {
        this.priceList.alternative[productId + ""] = {
          name: '',
          price: '',
          reason: '',
          totalPrice: ''
        }
      } else {
        delete this.priceList.alternative[productId + ""];
      }
    },

    openRatingPopup(companyId, profile) {
      this.openCompanyRatingStatisticPopup = companyId;
      this.openCompanyRatingStatisticPopupProfile = profile;
      this.$bvModal.show('modal-company-rate-statists');
    },
    exportResults(format) {

      exportRequestResult(this.token, this.request.id, format).then(data => {
        if (data.code === 200) {
          window.open(mediaBase + data.file);
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      });

    },

    showCoWorkerPopup() {

      getCompanyUsers(this.token).then(data => {
        if (data.code === 200) {
          this.companyUsers = data.users.filter(user => user.user.id !== this.user.id && user.profileType === this.request.profileType);


          this.$bvModal.show('modal-coworker');

        } else {
          this.$swal({
            title: this.$t("request.errCode", {code: data.code}),
            text: this.$t("request.srktIstfdcSyhsYklanmedi"),
            icon: 'error'
          })
        }
      });

    },

    setCoWorker() {
      if (this.selectedCoWorker) {
        setRequestCoWorker(this.token, this.request.id, this.selectedCoWorker).then(data => {
          if (data.code === 200) {
            this.$bvModal.hide('modal-coworker');
            this.selectedCoWorker = null;
            this.getRequest();
          } else {
            this.$swal({
              title: this.$t("request.errCode", {code: data.code}),
              text: this.$t("request.nzrtCTynEdilmedi"),
              icon: 'error'
            })
          }
        });
      } else {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("request.istfdciScin"),
          icon: 'warning'
        })
      }
    }
  }

}
</script>

<style scoped lang="scss">
.request-title {
  font-size: 18px;
  color: #233656;
}

.request-description {
  font-size: 14px;
  color: #5D6B82;
}

h4 {
  font-size: 18px;
  font-weight: bold;
}

.card {
  .card-header, .card-footer {
    padding: 30px;
  }

  .card-body {
    padding: 30px;
    font-size: 14px;
    color: #5D6B82;

    h4 {
      font-size: 16px;
      color: #233656;
    }

    p {
      font-size: 14px;
    }

    label {
      color: #233656;
    }
  }
}


.requestFile {
  display: block;
  background: rgba(#DEE5EF, 0.3);
  padding: 3px 10px;
  margin: 6px 0;
  border-radius: 6px;
}

.product-table {
  border: none;
  border-collapse: separate;
  border-spacing: 0 10px;

  thead {
    border: none;
    font-size: 13px;

    tr {
      border: none;

      th {
        border: none;
        font-weight: 400;
        color: #8B95A6;
      }
    }
  }

  tbody {

    tr {
      &:not(.not-found) {
        padding: 10px;
        background: #F9FAFC;
        white-space: nowrap;
        margin: 10px 0;
        border-radius: 6px;
        overflow: hidden;

        .can-wrap {
          white-space: normal;
        }

        td {
          &:first-child {
            border-radius: 6px 0 0 6px;
          }

          &:last-child {
            border-radius: 0 6px 6px 0;
          }
        }
      }

    }
  }

}

</style>
